export const sampleData = {
  "hotel": {
    "name": "Sample Hotel",
    "capacity": 150,
    "asOf": "2026-10-03"
  },
  "daily": [
    {
      "date": "2026-10-04",
      "event": "",
      "otbRooms": 84,
      "otbRevenue": 9240,
      "stlyRooms": 89,
      "stlyRevenue": 10591,
      "forecastRooms": 86,
      "bar": 133,
      "channels": {
        "Brand.com": {
          "ty": 31,
          "stly": 27
        },
        "Booking.com": {
          "ty": 25,
          "stly": 25
        },
        "Expedia": {
          "ty": 23,
          "stly": 20
        }
      }
    },
    {
      "date": "2026-10-05",
      "event": "",
      "otbRooms": 132,
      "otbRevenue": 19668,
      "stlyRooms": 123,
      "stlyRevenue": 17712,
      "forecastRooms": 141,
      "bar": 159,
      "channels": {
        "Brand.com": {
          "ty": 41,
          "stly": 31
        },
        "Booking.com": {
          "ty": 41,
          "stly": 34
        },
        "Expedia": {
          "ty": 37,
          "stly": 28
        }
      }
    },
    {
      "date": "2026-10-06",
      "event": "",
      "otbRooms": 117,
      "otbRevenue": 16497,
      "stlyRooms": 95,
      "stlyRevenue": 13110,
      "forecastRooms": 117,
      "bar": 154,
      "channels": {
        "Brand.com": {
          "ty": 45,
          "stly": 30
        },
        "Booking.com": {
          "ty": 40,
          "stly": 29
        },
        "Expedia": {
          "ty": 22,
          "stly": 15
        }
      }
    },
    {
      "date": "2026-10-07",
      "event": "",
      "otbRooms": 87,
      "otbRevenue": 12441,
      "stlyRooms": 97,
      "stlyRevenue": 13289,
      "forecastRooms": 124,
      "bar": 157,
      "channels": {
        "Brand.com": {
          "ty": 28,
          "stly": 25
        },
        "Booking.com": {
          "ty": 26,
          "stly": 26
        },
        "Expedia": {
          "ty": 20,
          "stly": 18
        }
      }
    },
    {
      "date": "2026-10-08",
      "event": "",
      "otbRooms": 93,
      "otbRevenue": 11904,
      "stlyRooms": 105,
      "stlyRevenue": 14280,
      "forecastRooms": 111,
      "bar": 145,
      "channels": {
        "Brand.com": {
          "ty": 34,
          "stly": 33
        },
        "Booking.com": {
          "ty": 31,
          "stly": 31
        },
        "Expedia": {
          "ty": 22,
          "stly": 21
        }
      }
    },
    {
      "date": "2026-10-09",
      "event": "",
      "otbRooms": 111,
      "otbRevenue": 18981,
      "stlyRooms": 115,
      "stlyRevenue": 17595,
      "forecastRooms": 127,
      "bar": 170,
      "channels": {
        "Brand.com": {
          "ty": 45,
          "stly": 42
        },
        "Booking.com": {
          "ty": 32,
          "stly": 33
        },
        "Expedia": {
          "ty": 27,
          "stly": 25
        }
      }
    },
    {
      "date": "2026-10-10",
      "event": "",
      "otbRooms": 126,
      "otbRevenue": 19026,
      "stlyRooms": 108,
      "stlyRevenue": 17064,
      "forecastRooms": 146,
      "bar": 169,
      "channels": {
        "Brand.com": {
          "ty": 44,
          "stly": 30
        },
        "Booking.com": {
          "ty": 43,
          "stly": 33
        },
        "Expedia": {
          "ty": 24,
          "stly": 16
        }
      }
    },
    {
      "date": "2026-10-11",
      "event": "",
      "otbRooms": 75,
      "otbRevenue": 10275,
      "stlyRooms": 85,
      "stlyRevenue": 10455,
      "forecastRooms": 87,
      "bar": 133,
      "channels": {
        "Brand.com": {
          "ty": 24,
          "stly": 22
        },
        "Booking.com": {
          "ty": 26,
          "stly": 26
        },
        "Expedia": {
          "ty": 16,
          "stly": 15
        }
      }
    },
    {
      "date": "2026-10-12",
      "event": "",
      "otbRooms": 90,
      "otbRevenue": 10890,
      "stlyRooms": 99,
      "stlyRevenue": 12672,
      "forecastRooms": 110,
      "bar": 152,
      "channels": {
        "Brand.com": {
          "ty": 33,
          "stly": 30
        },
        "Booking.com": {
          "ty": 28,
          "stly": 28
        },
        "Expedia": {
          "ty": 24,
          "stly": 19
        }
      }
    },
    {
      "date": "2026-10-13",
      "event": "",
      "otbRooms": 87,
      "otbRevenue": 12702,
      "stlyRooms": 96,
      "stlyRevenue": 13344,
      "forecastRooms": 117,
      "bar": 155,
      "channels": {
        "Brand.com": {
          "ty": 28,
          "stly": 24
        },
        "Booking.com": {
          "ty": 29,
          "stly": 29
        },
        "Expedia": {
          "ty": 24,
          "stly": 19
        }
      }
    },
    {
      "date": "2026-10-14",
      "event": "",
      "otbRooms": 129,
      "otbRevenue": 19608,
      "stlyRooms": 105,
      "stlyRevenue": 15855,
      "forecastRooms": 129,
      "bar": 157,
      "channels": {
        "Brand.com": {
          "ty": 51,
          "stly": 38
        },
        "Booking.com": {
          "ty": 38,
          "stly": 32
        },
        "Expedia": {
          "ty": 33,
          "stly": 22
        }
      }
    },
    {
      "date": "2026-10-15",
      "event": "",
      "otbRooms": 85,
      "otbRevenue": 11560,
      "stlyRooms": 80,
      "stlyRevenue": 10880,
      "forecastRooms": 96,
      "bar": 154,
      "channels": {
        "Brand.com": {
          "ty": 37,
          "stly": 29
        },
        "Booking.com": {
          "ty": 22,
          "stly": 20
        },
        "Expedia": {
          "ty": 19,
          "stly": 14
        }
      }
    },
    {
      "date": "2026-10-16",
      "event": "",
      "otbRooms": 99,
      "otbRevenue": 14553,
      "stlyRooms": 88,
      "stlyRevenue": 13112,
      "forecastRooms": 135,
      "bar": 159,
      "channels": {
        "Brand.com": {
          "ty": 31,
          "stly": 22
        },
        "Booking.com": {
          "ty": 34,
          "stly": 27
        },
        "Expedia": {
          "ty": 26,
          "stly": 17
        }
      }
    },
    {
      "date": "2026-10-17",
      "event": "",
      "otbRooms": 106,
      "otbRevenue": 15052,
      "stlyRooms": 87,
      "stlyRevenue": 13137,
      "forecastRooms": 144,
      "bar": 155,
      "channels": {
        "Brand.com": {
          "ty": 32,
          "stly": 21
        },
        "Booking.com": {
          "ty": 32,
          "stly": 23
        },
        "Expedia": {
          "ty": 29,
          "stly": 17
        }
      }
    },
    {
      "date": "2026-10-18",
      "event": "",
      "otbRooms": 88,
      "otbRevenue": 11616,
      "stlyRooms": 73,
      "stlyRevenue": 9271,
      "forecastRooms": 100,
      "bar": 133,
      "channels": {
        "Brand.com": {
          "ty": 32,
          "stly": 23
        },
        "Booking.com": {
          "ty": 23,
          "stly": 19
        },
        "Expedia": {
          "ty": 27,
          "stly": 18
        }
      }
    },
    {
      "date": "2026-10-19",
      "event": "",
      "otbRooms": 70,
      "otbRevenue": 10150,
      "stlyRooms": 82,
      "stlyRevenue": 11398,
      "forecastRooms": 106,
      "bar": 152,
      "channels": {
        "Brand.com": {
          "ty": 25,
          "stly": 26
        },
        "Booking.com": {
          "ty": 21,
          "stly": 24
        },
        "Expedia": {
          "ty": 19,
          "stly": 17
        }
      }
    },
    {
      "date": "2026-10-20",
      "event": "",
      "otbRooms": 87,
      "otbRevenue": 13137,
      "stlyRooms": 101,
      "stlyRevenue": 14847,
      "forecastRooms": 112,
      "bar": 154,
      "channels": {
        "Brand.com": {
          "ty": 30,
          "stly": 29
        },
        "Booking.com": {
          "ty": 25,
          "stly": 28
        },
        "Expedia": {
          "ty": 27,
          "stly": 23
        }
      }
    },
    {
      "date": "2026-10-21",
      "event": "",
      "otbRooms": 103,
      "otbRevenue": 13802,
      "stlyRooms": 91,
      "stlyRevenue": 12012,
      "forecastRooms": 121,
      "bar": 157,
      "channels": {
        "Brand.com": {
          "ty": 40,
          "stly": 30
        },
        "Booking.com": {
          "ty": 26,
          "stly": 21
        },
        "Expedia": {
          "ty": 30,
          "stly": 19
        }
      }
    },
    {
      "date": "2026-10-22",
      "event": "",
      "otbRooms": 66,
      "otbRevenue": 9306,
      "stlyRooms": 61,
      "stlyRevenue": 8235,
      "forecastRooms": 122,
      "bar": 149,
      "channels": {
        "Brand.com": {
          "ty": 24,
          "stly": 18
        },
        "Booking.com": {
          "ty": 18,
          "stly": 15
        },
        "Expedia": {
          "ty": 18,
          "stly": 12
        }
      }
    },
    {
      "date": "2026-10-23",
      "event": "",
      "otbRooms": 104,
      "otbRevenue": 16016,
      "stlyRooms": 105,
      "stlyRevenue": 15855,
      "forecastRooms": 136,
      "bar": 170,
      "channels": {
        "Brand.com": {
          "ty": 42,
          "stly": 35
        },
        "Booking.com": {
          "ty": 29,
          "stly": 27
        },
        "Expedia": {
          "ty": 26,
          "stly": 20
        }
      }
    },
    {
      "date": "2026-10-24",
      "event": "",
      "otbRooms": 78,
      "otbRevenue": 10764,
      "stlyRooms": 64,
      "stlyRevenue": 9408,
      "forecastRooms": 138,
      "bar": 152,
      "channels": {
        "Brand.com": {
          "ty": 28,
          "stly": 18
        },
        "Booking.com": {
          "ty": 25,
          "stly": 18
        },
        "Expedia": {
          "ty": 19,
          "stly": 11
        }
      }
    },
    {
      "date": "2026-10-25",
      "event": "",
      "otbRooms": 57,
      "otbRevenue": 6897,
      "stlyRooms": 60,
      "stlyRevenue": 6600,
      "forecastRooms": 82,
      "bar": 133,
      "channels": {
        "Brand.com": {
          "ty": 20,
          "stly": 19
        },
        "Booking.com": {
          "ty": 22,
          "stly": 24
        },
        "Expedia": {
          "ty": 11,
          "stly": 10
        }
      }
    },
    {
      "date": "2026-10-26",
      "event": "",
      "otbRooms": 73,
      "otbRevenue": 10439,
      "stlyRooms": 72,
      "stlyRevenue": 10440,
      "forecastRooms": 100,
      "bar": 152,
      "channels": {
        "Brand.com": {
          "ty": 30,
          "stly": 23
        },
        "Booking.com": {
          "ty": 16,
          "stly": 14
        },
        "Expedia": {
          "ty": 20,
          "stly": 14
        }
      }
    },
    {
      "date": "2026-10-27",
      "event": "",
      "otbRooms": 93,
      "otbRevenue": 11811,
      "stlyRooms": 106,
      "stlyRevenue": 14098,
      "forecastRooms": 127,
      "bar": 154,
      "channels": {
        "Brand.com": {
          "ty": 33,
          "stly": 30
        },
        "Booking.com": {
          "ty": 23,
          "stly": 24
        },
        "Expedia": {
          "ty": 22,
          "stly": 18
        }
      }
    },
    {
      "date": "2026-10-28",
      "event": "",
      "otbRooms": 58,
      "otbRevenue": 9048,
      "stlyRooms": 77,
      "stlyRevenue": 11165,
      "forecastRooms": 111,
      "bar": 157,
      "channels": {
        "Brand.com": {
          "ty": 19,
          "stly": 21
        },
        "Booking.com": {
          "ty": 16,
          "stly": 19
        },
        "Expedia": {
          "ty": 18,
          "stly": 18
        }
      }
    },
    {
      "date": "2026-10-29",
      "event": "",
      "otbRooms": 108,
      "otbRevenue": 15660,
      "stlyRooms": 84,
      "stlyRevenue": 12012,
      "forecastRooms": 121,
      "bar": 154,
      "channels": {
        "Brand.com": {
          "ty": 32,
          "stly": 20
        },
        "Booking.com": {
          "ty": 30,
          "stly": 21
        },
        "Expedia": {
          "ty": 31,
          "stly": 17
        }
      }
    },
    {
      "date": "2026-10-30",
      "event": "",
      "otbRooms": 70,
      "otbRevenue": 10780,
      "stlyRooms": 65,
      "stlyRevenue": 10075,
      "forecastRooms": 138,
      "bar": 170,
      "channels": {
        "Brand.com": {
          "ty": 18,
          "stly": 14
        },
        "Booking.com": {
          "ty": 22,
          "stly": 18
        },
        "Expedia": {
          "ty": 19,
          "stly": 13
        }
      }
    },
    {
      "date": "2026-10-31",
      "event": "Halloween",
      "otbRooms": 57,
      "otbRevenue": 8664,
      "stlyRooms": 66,
      "stlyRevenue": 9306,
      "forecastRooms": 114,
      "bar": 165,
      "channels": {
        "Brand.com": {
          "ty": 24,
          "stly": 24
        },
        "Booking.com": {
          "ty": 15,
          "stly": 17
        },
        "Expedia": {
          "ty": 13,
          "stly": 11
        }
      }
    },
    {
      "date": "2026-11-01",
      "event": "",
      "otbRooms": 38,
      "otbRevenue": 4332,
      "stlyRooms": 47,
      "stlyRevenue": 5452,
      "forecastRooms": 76,
      "bar": 128,
      "channels": {
        "Brand.com": {
          "ty": 14,
          "stly": 14
        },
        "Booking.com": {
          "ty": 11,
          "stly": 12
        },
        "Expedia": {
          "ty": 8,
          "stly": 8
        }
      }
    },
    {
      "date": "2026-11-02",
      "event": "",
      "otbRooms": 62,
      "otbRevenue": 9238,
      "stlyRooms": 57,
      "stlyRevenue": 8094,
      "forecastRooms": 102,
      "bar": 146,
      "channels": {
        "Brand.com": {
          "ty": 19,
          "stly": 14
        },
        "Booking.com": {
          "ty": 19,
          "stly": 16
        },
        "Expedia": {
          "ty": 16,
          "stly": 12
        }
      }
    },
    {
      "date": "2026-11-03",
      "event": "",
      "otbRooms": 66,
      "otbRevenue": 8844,
      "stlyRooms": 59,
      "stlyRevenue": 8083,
      "forecastRooms": 102,
      "bar": 148,
      "channels": {
        "Brand.com": {
          "ty": 17,
          "stly": 12
        },
        "Booking.com": {
          "ty": 17,
          "stly": 13
        },
        "Expedia": {
          "ty": 19,
          "stly": 13
        }
      }
    },
    {
      "date": "2026-11-04",
      "event": "",
      "otbRooms": 85,
      "otbRevenue": 10795,
      "stlyRooms": 66,
      "stlyRevenue": 9306,
      "forecastRooms": 120,
      "bar": 150,
      "channels": {
        "Brand.com": {
          "ty": 40,
          "stly": 26
        },
        "Booking.com": {
          "ty": 27,
          "stly": 20
        },
        "Expedia": {
          "ty": 13,
          "stly": 9
        }
      }
    },
    {
      "date": "2026-11-05",
      "event": "",
      "otbRooms": 64,
      "otbRevenue": 8448,
      "stlyRooms": 57,
      "stlyRevenue": 8094,
      "forecastRooms": 107,
      "bar": 148,
      "channels": {
        "Brand.com": {
          "ty": 25,
          "stly": 18
        },
        "Booking.com": {
          "ty": 21,
          "stly": 16
        },
        "Expedia": {
          "ty": 14,
          "stly": 10
        }
      }
    },
    {
      "date": "2026-11-06",
      "event": "",
      "otbRooms": 66,
      "otbRevenue": 10098,
      "stlyRooms": 87,
      "stlyRevenue": 13398,
      "forecastRooms": 126,
      "bar": 164,
      "channels": {
        "Brand.com": {
          "ty": 24,
          "stly": 26
        },
        "Booking.com": {
          "ty": 21,
          "stly": 25
        },
        "Expedia": {
          "ty": 15,
          "stly": 16
        }
      }
    },
    {
      "date": "2026-11-07",
      "event": "",
      "otbRooms": 50,
      "otbRevenue": 6450,
      "stlyRooms": 54,
      "stlyRevenue": 7236,
      "forecastRooms": 118,
      "bar": 142,
      "channels": {
        "Brand.com": {
          "ty": 17,
          "stly": 16
        },
        "Booking.com": {
          "ty": 16,
          "stly": 16
        },
        "Expedia": {
          "ty": 12,
          "stly": 11
        }
      }
    },
    {
      "date": "2026-11-08",
      "event": "",
      "otbRooms": 40,
      "otbRevenue": 4640,
      "stlyRooms": 38,
      "stlyRevenue": 4218,
      "forecastRooms": 79,
      "bar": 128,
      "channels": {
        "Brand.com": {
          "ty": 14,
          "stly": 11
        },
        "Booking.com": {
          "ty": 9,
          "stly": 8
        },
        "Expedia": {
          "ty": 9,
          "stly": 7
        }
      }
    },
    {
      "date": "2026-11-09",
      "event": "",
      "otbRooms": 54,
      "otbRevenue": 6750,
      "stlyRooms": 51,
      "stlyRevenue": 6630,
      "forecastRooms": 102,
      "bar": 146,
      "channels": {
        "Brand.com": {
          "ty": 17,
          "stly": 13
        },
        "Booking.com": {
          "ty": 16,
          "stly": 13
        },
        "Expedia": {
          "ty": 15,
          "stly": 11
        }
      }
    },
    {
      "date": "2026-11-10",
      "event": "",
      "otbRooms": 59,
      "otbRevenue": 8142,
      "stlyRooms": 62,
      "stlyRevenue": 8804,
      "forecastRooms": 103,
      "bar": 148,
      "channels": {
        "Brand.com": {
          "ty": 24,
          "stly": 22
        },
        "Booking.com": {
          "ty": 18,
          "stly": 19
        },
        "Expedia": {
          "ty": 13,
          "stly": 12
        }
      }
    },
    {
      "date": "2026-11-11",
      "event": "",
      "otbRooms": 50,
      "otbRevenue": 6750,
      "stlyRooms": 51,
      "stlyRevenue": 6783,
      "forecastRooms": 101,
      "bar": 150,
      "channels": {
        "Brand.com": {
          "ty": 16,
          "stly": 14
        },
        "Booking.com": {
          "ty": 16,
          "stly": 16
        },
        "Expedia": {
          "ty": 13,
          "stly": 11
        }
      }
    },
    {
      "date": "2026-11-12",
      "event": "",
      "otbRooms": 56,
      "otbRevenue": 7224,
      "stlyRooms": 42,
      "stlyRevenue": 5586,
      "forecastRooms": 100,
      "bar": 148,
      "channels": {
        "Brand.com": {
          "ty": 23,
          "stly": 15
        },
        "Booking.com": {
          "ty": 16,
          "stly": 12
        },
        "Expedia": {
          "ty": 13,
          "stly": 8
        }
      }
    },
    {
      "date": "2026-11-13",
      "event": "",
      "otbRooms": 60,
      "otbRevenue": 8640,
      "stlyRooms": 69,
      "stlyRevenue": 9936,
      "forecastRooms": 112,
      "bar": 164,
      "channels": {
        "Brand.com": {
          "ty": 16,
          "stly": 15
        },
        "Booking.com": {
          "ty": 21,
          "stly": 21
        },
        "Expedia": {
          "ty": 15,
          "stly": 14
        }
      }
    },
    {
      "date": "2026-11-14",
      "event": "",
      "otbRooms": 45,
      "otbRevenue": 6525,
      "stlyRooms": 36,
      "stlyRevenue": 5040,
      "forecastRooms": 132,
      "bar": 155,
      "channels": {
        "Brand.com": {
          "ty": 16,
          "stly": 11
        },
        "Booking.com": {
          "ty": 13,
          "stly": 10
        },
        "Expedia": {
          "ty": 13,
          "stly": 9
        }
      }
    },
    {
      "date": "2026-11-15",
      "event": "",
      "otbRooms": 28,
      "otbRevenue": 2772,
      "stlyRooms": 25,
      "stlyRevenue": 2650,
      "forecastRooms": 67,
      "bar": 128,
      "channels": {
        "Brand.com": {
          "ty": 8,
          "stly": 6
        },
        "Booking.com": {
          "ty": 8,
          "stly": 7
        },
        "Expedia": {
          "ty": 6,
          "stly": 4
        }
      }
    },
    {
      "date": "2026-11-16",
      "event": "",
      "otbRooms": 50,
      "otbRevenue": 7100,
      "stlyRooms": 50,
      "stlyRevenue": 6650,
      "forecastRooms": 112,
      "bar": 146,
      "channels": {
        "Brand.com": {
          "ty": 17,
          "stly": 14
        },
        "Booking.com": {
          "ty": 16,
          "stly": 15
        },
        "Expedia": {
          "ty": 12,
          "stly": 10
        }
      }
    },
    {
      "date": "2026-11-17",
      "event": "",
      "otbRooms": 48,
      "otbRevenue": 6960,
      "stlyRooms": 53,
      "stlyRevenue": 7155,
      "forecastRooms": 107,
      "bar": 148,
      "channels": {
        "Brand.com": {
          "ty": 20,
          "stly": 18
        },
        "Booking.com": {
          "ty": 13,
          "stly": 13
        },
        "Expedia": {
          "ty": 12,
          "stly": 11
        }
      }
    },
    {
      "date": "2026-11-18",
      "event": "",
      "otbRooms": 39,
      "otbRevenue": 5187,
      "stlyRooms": 45,
      "stlyRevenue": 6390,
      "forecastRooms": 96,
      "bar": 150,
      "channels": {
        "Brand.com": {
          "ty": 17,
          "stly": 16
        },
        "Booking.com": {
          "ty": 13,
          "stly": 15
        },
        "Expedia": {
          "ty": 5,
          "stly": 6
        }
      }
    },
    {
      "date": "2026-11-19",
      "event": "",
      "otbRooms": 37,
      "otbRevenue": 5180,
      "stlyRooms": 44,
      "stlyRevenue": 5940,
      "forecastRooms": 94,
      "bar": 148,
      "channels": {
        "Brand.com": {
          "ty": 16,
          "stly": 16
        },
        "Booking.com": {
          "ty": 9,
          "stly": 11
        },
        "Expedia": {
          "ty": 8,
          "stly": 9
        }
      }
    },
    {
      "date": "2026-11-20",
      "event": "",
      "otbRooms": 52,
      "otbRevenue": 7748,
      "stlyRooms": 52,
      "stlyRevenue": 7436,
      "forecastRooms": 118,
      "bar": 164,
      "channels": {
        "Brand.com": {
          "ty": 20,
          "stly": 18
        },
        "Booking.com": {
          "ty": 16,
          "stly": 16
        },
        "Expedia": {
          "ty": 12,
          "stly": 10
        }
      }
    },
    {
      "date": "2026-11-21",
      "event": "",
      "otbRooms": 57,
      "otbRevenue": 7866,
      "stlyRooms": 54,
      "stlyRevenue": 8208,
      "forecastRooms": 129,
      "bar": 167,
      "channels": {
        "Brand.com": {
          "ty": 21,
          "stly": 17
        },
        "Booking.com": {
          "ty": 19,
          "stly": 17
        },
        "Expedia": {
          "ty": 12,
          "stly": 10
        }
      }
    },
    {
      "date": "2026-11-22",
      "event": "",
      "otbRooms": 28,
      "otbRevenue": 3276,
      "stlyRooms": 24,
      "stlyRevenue": 2832,
      "forecastRooms": 72,
      "bar": 128,
      "channels": {
        "Brand.com": {
          "ty": 11,
          "stly": 8
        },
        "Booking.com": {
          "ty": 8,
          "stly": 6
        },
        "Expedia": {
          "ty": 6,
          "stly": 4
        }
      }
    },
    {
      "date": "2026-11-23",
      "event": "",
      "otbRooms": 44,
      "otbRevenue": 5676,
      "stlyRooms": 40,
      "stlyRevenue": 5280,
      "forecastRooms": 98,
      "bar": 146,
      "channels": {
        "Brand.com": {
          "ty": 17,
          "stly": 12
        },
        "Booking.com": {
          "ty": 12,
          "stly": 10
        },
        "Expedia": {
          "ty": 12,
          "stly": 9
        }
      }
    },
    {
      "date": "2026-11-24",
      "event": "",
      "otbRooms": 47,
      "otbRevenue": 5781,
      "stlyRooms": 45,
      "stlyRevenue": 5940,
      "forecastRooms": 115,
      "bar": 148,
      "channels": {
        "Brand.com": {
          "ty": 14,
          "stly": 11
        },
        "Booking.com": {
          "ty": 17,
          "stly": 16
        },
        "Expedia": {
          "ty": 13,
          "stly": 11
        }
      }
    },
    {
      "date": "2026-11-25",
      "event": "",
      "otbRooms": 41,
      "otbRevenue": 5371,
      "stlyRooms": 44,
      "stlyRevenue": 5764,
      "forecastRooms": 112,
      "bar": 150,
      "channels": {
        "Brand.com": {
          "ty": 19,
          "stly": 16
        },
        "Booking.com": {
          "ty": 10,
          "stly": 10
        },
        "Expedia": {
          "ty": 8,
          "stly": 7
        }
      }
    },
    {
      "date": "2026-11-26",
      "event": "Thanksgiving",
      "otbRooms": 27,
      "otbRevenue": 3186,
      "stlyRooms": 33,
      "stlyRevenue": 4092,
      "forecastRooms": 87,
      "bar": 129,
      "channels": {
        "Brand.com": {
          "ty": 6,
          "stly": 6
        },
        "Booking.com": {
          "ty": 8,
          "stly": 9
        },
        "Expedia": {
          "ty": 8,
          "stly": 8
        }
      }
    },
    {
      "date": "2026-11-27",
      "event": "",
      "otbRooms": 37,
      "otbRevenue": 5957,
      "stlyRooms": 46,
      "stlyRevenue": 6762,
      "forecastRooms": 113,
      "bar": 164,
      "channels": {
        "Brand.com": {
          "ty": 13,
          "stly": 13
        },
        "Booking.com": {
          "ty": 9,
          "stly": 10
        },
        "Expedia": {
          "ty": 9,
          "stly": 9
        }
      }
    },
    {
      "date": "2026-11-28",
      "event": "",
      "otbRooms": 49,
      "otbRevenue": 8183,
      "stlyRooms": 46,
      "stlyRevenue": 7084,
      "forecastRooms": 126,
      "bar": 167,
      "channels": {
        "Brand.com": {
          "ty": 15,
          "stly": 12
        },
        "Booking.com": {
          "ty": 19,
          "stly": 17
        },
        "Expedia": {
          "ty": 11,
          "stly": 9
        }
      }
    },
    {
      "date": "2026-11-29",
      "event": "",
      "otbRooms": 28,
      "otbRevenue": 2940,
      "stlyRooms": 36,
      "stlyRevenue": 4068,
      "forecastRooms": 90,
      "bar": 128,
      "channels": {
        "Brand.com": {
          "ty": 11,
          "stly": 11
        },
        "Booking.com": {
          "ty": 8,
          "stly": 9
        },
        "Expedia": {
          "ty": 6,
          "stly": 6
        }
      }
    },
    {
      "date": "2026-11-30",
      "event": "",
      "otbRooms": 31,
      "otbRevenue": 3906,
      "stlyRooms": 32,
      "stlyRevenue": 4224,
      "forecastRooms": 95,
      "bar": 146,
      "channels": {
        "Brand.com": {
          "ty": 11,
          "stly": 10
        },
        "Booking.com": {
          "ty": 9,
          "stly": 9
        },
        "Expedia": {
          "ty": 8,
          "stly": 7
        }
      }
    },
    {
      "date": "2026-12-01",
      "event": "",
      "otbRooms": 30,
      "otbRevenue": 3690,
      "stlyRooms": 30,
      "stlyRevenue": 3660,
      "forecastRooms": 81,
      "bar": 144,
      "channels": {
        "Brand.com": {
          "ty": 13,
          "stly": 10
        },
        "Booking.com": {
          "ty": 9,
          "stly": 8
        },
        "Expedia": {
          "ty": 6,
          "stly": 6
        }
      }
    },
    {
      "date": "2026-12-02",
      "event": "",
      "otbRooms": 31,
      "otbRevenue": 4278,
      "stlyRooms": 33,
      "stlyRevenue": 4587,
      "forecastRooms": 97,
      "bar": 146,
      "channels": {
        "Brand.com": {
          "ty": 11,
          "stly": 9
        },
        "Booking.com": {
          "ty": 10,
          "stly": 10
        },
        "Expedia": {
          "ty": 5,
          "stly": 5
        }
      }
    },
    {
      "date": "2026-12-03",
      "event": "",
      "otbRooms": 29,
      "otbRevenue": 3857,
      "stlyRooms": 30,
      "stlyRevenue": 4080,
      "forecastRooms": 83,
      "bar": 144,
      "channels": {
        "Brand.com": {
          "ty": 12,
          "stly": 10
        },
        "Booking.com": {
          "ty": 9,
          "stly": 9
        },
        "Expedia": {
          "ty": 6,
          "stly": 6
        }
      }
    },
    {
      "date": "2026-12-04",
      "event": "",
      "otbRooms": 35,
      "otbRevenue": 4725,
      "stlyRooms": 32,
      "stlyRevenue": 4640,
      "forecastRooms": 100,
      "bar": 159,
      "channels": {
        "Brand.com": {
          "ty": 12,
          "stly": 9
        },
        "Booking.com": {
          "ty": 7,
          "stly": 6
        },
        "Expedia": {
          "ty": 8,
          "stly": 7
        }
      }
    },
    {
      "date": "2026-12-05",
      "event": "",
      "otbRooms": 34,
      "otbRevenue": 4352,
      "stlyRooms": 34,
      "stlyRevenue": 4964,
      "forecastRooms": 117,
      "bar": 162,
      "channels": {
        "Brand.com": {
          "ty": 12,
          "stly": 9
        },
        "Booking.com": {
          "ty": 10,
          "stly": 9
        },
        "Expedia": {
          "ty": 7,
          "stly": 7
        }
      }
    },
    {
      "date": "2026-12-06",
      "event": "",
      "otbRooms": 23,
      "otbRevenue": 2783,
      "stlyRooms": 24,
      "stlyRevenue": 2688,
      "forecastRooms": 78,
      "bar": 124,
      "channels": {
        "Brand.com": {
          "ty": 6,
          "stly": 5
        },
        "Booking.com": {
          "ty": 7,
          "stly": 7
        },
        "Expedia": {
          "ty": 4,
          "stly": 4
        }
      }
    },
    {
      "date": "2026-12-07",
      "event": "",
      "otbRooms": 22,
      "otbRevenue": 2442,
      "stlyRooms": 22,
      "stlyRevenue": 2684,
      "forecastRooms": 80,
      "bar": 142,
      "channels": {
        "Brand.com": {
          "ty": 9,
          "stly": 7
        },
        "Booking.com": {
          "ty": 6,
          "stly": 6
        },
        "Expedia": {
          "ty": 3,
          "stly": 3
        }
      }
    },
    {
      "date": "2026-12-08",
      "event": "",
      "otbRooms": 27,
      "otbRevenue": 3591,
      "stlyRooms": 25,
      "stlyRevenue": 3400,
      "forecastRooms": 93,
      "bar": 144,
      "channels": {
        "Brand.com": {
          "ty": 11,
          "stly": 8
        },
        "Booking.com": {
          "ty": 7,
          "stly": 6
        },
        "Expedia": {
          "ty": 6,
          "stly": 5
        }
      }
    },
    {
      "date": "2026-12-09",
      "event": "",
      "otbRooms": 36,
      "otbRevenue": 5148,
      "stlyRooms": 33,
      "stlyRevenue": 5016,
      "forecastRooms": 112,
      "bar": 146,
      "channels": {
        "Brand.com": {
          "ty": 15,
          "stly": 11
        },
        "Booking.com": {
          "ty": 8,
          "stly": 7
        },
        "Expedia": {
          "ty": 8,
          "stly": 7
        }
      }
    },
    {
      "date": "2026-12-10",
      "event": "",
      "otbRooms": 24,
      "otbRevenue": 3072,
      "stlyRooms": 25,
      "stlyRevenue": 3200,
      "forecastRooms": 95,
      "bar": 144,
      "channels": {
        "Brand.com": {
          "ty": 7,
          "stly": 6
        },
        "Booking.com": {
          "ty": 6,
          "stly": 6
        },
        "Expedia": {
          "ty": 6,
          "stly": 6
        }
      }
    },
    {
      "date": "2026-12-11",
      "event": "",
      "otbRooms": 30,
      "otbRevenue": 4230,
      "stlyRooms": 30,
      "stlyRevenue": 4170,
      "forecastRooms": 101,
      "bar": 159,
      "channels": {
        "Brand.com": {
          "ty": 12,
          "stly": 10
        },
        "Booking.com": {
          "ty": 10,
          "stly": 10
        },
        "Expedia": {
          "ty": 5,
          "stly": 6
        }
      }
    },
    {
      "date": "2026-12-12",
      "event": "",
      "otbRooms": 30,
      "otbRevenue": 4110,
      "stlyRooms": 30,
      "stlyRevenue": 4410,
      "forecastRooms": 103,
      "bar": 162,
      "channels": {
        "Brand.com": {
          "ty": 10,
          "stly": 8
        },
        "Booking.com": {
          "ty": 6,
          "stly": 6
        },
        "Expedia": {
          "ty": 6,
          "stly": 6
        }
      }
    },
    {
      "date": "2026-12-13",
      "event": "",
      "otbRooms": 22,
      "otbRevenue": 2662,
      "stlyRooms": 25,
      "stlyRevenue": 2875,
      "forecastRooms": 84,
      "bar": 124,
      "channels": {
        "Brand.com": {
          "ty": 8,
          "stly": 7
        },
        "Booking.com": {
          "ty": 6,
          "stly": 6
        },
        "Expedia": {
          "ty": 5,
          "stly": 5
        }
      }
    },
    {
      "date": "2026-12-14",
      "event": "",
      "otbRooms": 24,
      "otbRevenue": 3336,
      "stlyRooms": 20,
      "stlyRevenue": 2540,
      "forecastRooms": 93,
      "bar": 142,
      "channels": {
        "Brand.com": {
          "ty": 9,
          "stly": 6
        },
        "Booking.com": {
          "ty": 8,
          "stly": 6
        },
        "Expedia": {
          "ty": 4,
          "stly": 3
        }
      }
    },
    {
      "date": "2026-12-15",
      "event": "",
      "otbRooms": 26,
      "otbRevenue": 3302,
      "stlyRooms": 28,
      "stlyRevenue": 3360,
      "forecastRooms": 104,
      "bar": 144,
      "channels": {
        "Brand.com": {
          "ty": 10,
          "stly": 9
        },
        "Booking.com": {
          "ty": 4,
          "stly": 4
        },
        "Expedia": {
          "ty": 4,
          "stly": 4
        }
      }
    },
    {
      "date": "2026-12-16",
      "event": "",
      "otbRooms": 21,
      "otbRevenue": 2583,
      "stlyRooms": 23,
      "stlyRevenue": 2898,
      "forecastRooms": 92,
      "bar": 146,
      "channels": {
        "Brand.com": {
          "ty": 9,
          "stly": 8
        },
        "Booking.com": {
          "ty": 6,
          "stly": 6
        },
        "Expedia": {
          "ty": 4,
          "stly": 4
        }
      }
    },
    {
      "date": "2026-12-17",
      "event": "",
      "otbRooms": 22,
      "otbRevenue": 2772,
      "stlyRooms": 19,
      "stlyRevenue": 2508,
      "forecastRooms": 92,
      "bar": 144,
      "channels": {
        "Brand.com": {
          "ty": 8,
          "stly": 6
        },
        "Booking.com": {
          "ty": 7,
          "stly": 6
        },
        "Expedia": {
          "ty": 4,
          "stly": 4
        }
      }
    },
    {
      "date": "2026-12-18",
      "event": "",
      "otbRooms": 24,
      "otbRevenue": 3288,
      "stlyRooms": 19,
      "stlyRevenue": 2622,
      "forecastRooms": 93,
      "bar": 159,
      "channels": {
        "Brand.com": {
          "ty": 8,
          "stly": 5
        },
        "Booking.com": {
          "ty": 4,
          "stly": 3
        },
        "Expedia": {
          "ty": 5,
          "stly": 4
        }
      }
    },
    {
      "date": "2026-12-19",
      "event": "",
      "otbRooms": 22,
      "otbRevenue": 3124,
      "stlyRooms": 23,
      "stlyRevenue": 3542,
      "forecastRooms": 104,
      "bar": 162,
      "channels": {
        "Brand.com": {
          "ty": 6,
          "stly": 5
        },
        "Booking.com": {
          "ty": 6,
          "stly": 6
        },
        "Expedia": {
          "ty": 4,
          "stly": 4
        }
      }
    },
    {
      "date": "2026-12-20",
      "event": "",
      "otbRooms": 24,
      "otbRevenue": 2544,
      "stlyRooms": 16,
      "stlyRevenue": 1792,
      "forecastRooms": 79,
      "bar": 124,
      "channels": {
        "Brand.com": {
          "ty": 8,
          "stly": 4
        },
        "Booking.com": {
          "ty": 7,
          "stly": 4
        },
        "Expedia": {
          "ty": 3,
          "stly": 2
        }
      }
    },
    {
      "date": "2026-12-21",
      "event": "",
      "otbRooms": 22,
      "otbRevenue": 3036,
      "stlyRooms": 26,
      "stlyRevenue": 3432,
      "forecastRooms": 102,
      "bar": 142,
      "channels": {
        "Brand.com": {
          "ty": 9,
          "stly": 8
        },
        "Booking.com": {
          "ty": 7,
          "stly": 8
        },
        "Expedia": {
          "ty": 3,
          "stly": 4
        }
      }
    },
    {
      "date": "2026-12-22",
      "event": "",
      "otbRooms": 22,
      "otbRevenue": 2970,
      "stlyRooms": 26,
      "stlyRevenue": 3380,
      "forecastRooms": 95,
      "bar": 144,
      "channels": {
        "Brand.com": {
          "ty": 7,
          "stly": 7
        },
        "Booking.com": {
          "ty": 7,
          "stly": 8
        },
        "Expedia": {
          "ty": 5,
          "stly": 6
        }
      }
    },
    {
      "date": "2026-12-23",
      "event": "",
      "otbRooms": 18,
      "otbRevenue": 2610,
      "stlyRooms": 19,
      "stlyRevenue": 2508,
      "forecastRooms": 90,
      "bar": 146,
      "channels": {
        "Brand.com": {
          "ty": 7,
          "stly": 6
        },
        "Booking.com": {
          "ty": 4,
          "stly": 4
        },
        "Expedia": {
          "ty": 3,
          "stly": 3
        }
      }
    },
    {
      "date": "2026-12-24",
      "event": "",
      "otbRooms": 16,
      "otbRevenue": 2192,
      "stlyRooms": 14,
      "stlyRevenue": 1806,
      "forecastRooms": 69,
      "bar": 144,
      "channels": {
        "Brand.com": {
          "ty": 6,
          "stly": 4
        },
        "Booking.com": {
          "ty": 4,
          "stly": 3
        },
        "Expedia": {
          "ty": 4,
          "stly": 3
        }
      }
    },
    {
      "date": "2026-12-25",
      "event": "Christmas Day",
      "otbRooms": 11,
      "otbRevenue": 1452,
      "stlyRooms": 13,
      "stlyRevenue": 1807,
      "forecastRooms": 60,
      "bar": 159,
      "channels": {
        "Brand.com": {
          "ty": 3,
          "stly": 3
        },
        "Booking.com": {
          "ty": 3,
          "stly": 3
        },
        "Expedia": {
          "ty": 2,
          "stly": 2
        }
      }
    },
    {
      "date": "2026-12-26",
      "event": "",
      "otbRooms": 22,
      "otbRevenue": 3652,
      "stlyRooms": 25,
      "stlyRevenue": 4250,
      "forecastRooms": 127,
      "bar": 187,
      "channels": {
        "Brand.com": {
          "ty": 9,
          "stly": 8
        },
        "Booking.com": {
          "ty": 4,
          "stly": 4
        },
        "Expedia": {
          "ty": 4,
          "stly": 4
        }
      }
    },
    {
      "date": "2026-12-27",
      "event": "",
      "otbRooms": 13,
      "otbRevenue": 1625,
      "stlyRooms": 11,
      "stlyRevenue": 1452,
      "forecastRooms": 66,
      "bar": 143,
      "channels": {
        "Brand.com": {
          "ty": 6,
          "stly": 4
        },
        "Booking.com": {
          "ty": 4,
          "stly": 3
        },
        "Expedia": {
          "ty": 2,
          "stly": 2
        }
      }
    },
    {
      "date": "2026-12-28",
      "event": "",
      "otbRooms": 21,
      "otbRevenue": 3297,
      "stlyRooms": 16,
      "stlyRevenue": 2560,
      "forecastRooms": 120,
      "bar": 164,
      "channels": {
        "Brand.com": {
          "ty": 8,
          "stly": 5
        },
        "Booking.com": {
          "ty": 4,
          "stly": 3
        },
        "Expedia": {
          "ty": 4,
          "stly": 3
        }
      }
    },
    {
      "date": "2026-12-29",
      "event": "",
      "otbRooms": 21,
      "otbRevenue": 3339,
      "stlyRooms": 14,
      "stlyRevenue": 2170,
      "forecastRooms": 106,
      "bar": 166,
      "channels": {
        "Brand.com": {
          "ty": 7,
          "stly": 4
        },
        "Booking.com": {
          "ty": 7,
          "stly": 4
        },
        "Expedia": {
          "ty": 5,
          "stly": 3
        }
      }
    },
    {
      "date": "2026-12-30",
      "event": "",
      "otbRooms": 20,
      "otbRevenue": 3560,
      "stlyRooms": 20,
      "stlyRevenue": 3260,
      "forecastRooms": 121,
      "bar": 169,
      "channels": {
        "Brand.com": {
          "ty": 9,
          "stly": 7
        },
        "Booking.com": {
          "ty": 6,
          "stly": 6
        },
        "Expedia": {
          "ty": 4,
          "stly": 4
        }
      }
    },
    {
      "date": "2026-12-31",
      "event": "New Year's Eve",
      "otbRooms": 39,
      "otbRevenue": 7371,
      "stlyRooms": 22,
      "stlyRevenue": 4378,
      "forecastRooms": 140,
      "bar": 209,
      "channels": {
        "Brand.com": {
          "ty": 13,
          "stly": 6
        },
        "Booking.com": {
          "ty": 12,
          "stly": 6
        },
        "Expedia": {
          "ty": 7,
          "stly": 4
        }
      }
    },
    {
      "date": "2027-01-01",
      "event": "",
      "otbRooms": 14,
      "otbRevenue": 1960,
      "stlyRooms": 16,
      "stlyRevenue": 2256,
      "forecastRooms": 95,
      "bar": 154,
      "channels": {
        "Brand.com": {
          "ty": 4,
          "stly": 4
        },
        "Booking.com": {
          "ty": 4,
          "stly": 5
        },
        "Expedia": {
          "ty": 3,
          "stly": 3
        }
      }
    },
    {
      "date": "2027-01-02",
      "event": "",
      "otbRooms": 12,
      "otbRevenue": 1752,
      "stlyRooms": 13,
      "stlyRevenue": 1859,
      "forecastRooms": 82,
      "bar": 157,
      "channels": {
        "Brand.com": {
          "ty": 4,
          "stly": 3
        },
        "Booking.com": {
          "ty": 3,
          "stly": 3
        },
        "Expedia": {
          "ty": 2,
          "stly": 2
        }
      }
    },
    {
      "date": "2027-01-03",
      "event": "",
      "otbRooms": 11,
      "otbRevenue": 1309,
      "stlyRooms": 11,
      "stlyRevenue": 1265,
      "forecastRooms": 66,
      "bar": 120,
      "channels": {
        "Brand.com": {
          "ty": 3,
          "stly": 3
        },
        "Booking.com": {
          "ty": 3,
          "stly": 4
        },
        "Expedia": {
          "ty": 2,
          "stly": 3
        }
      }
    },
    {
      "date": "2027-01-04",
      "event": "",
      "otbRooms": 15,
      "otbRevenue": 1920,
      "stlyRooms": 15,
      "stlyRevenue": 1860,
      "forecastRooms": 97,
      "bar": 138,
      "channels": {
        "Brand.com": {
          "ty": 6,
          "stly": 5
        },
        "Booking.com": {
          "ty": 4,
          "stly": 4
        },
        "Expedia": {
          "ty": 3,
          "stly": 3
        }
      }
    },
    {
      "date": "2027-01-05",
      "event": "",
      "otbRooms": 13,
      "otbRevenue": 1547,
      "stlyRooms": 12,
      "stlyRevenue": 1512,
      "forecastRooms": 88,
      "bar": 140,
      "channels": {
        "Brand.com": {
          "ty": 5,
          "stly": 4
        },
        "Booking.com": {
          "ty": 3,
          "stly": 3
        },
        "Expedia": {
          "ty": 2,
          "stly": 2
        }
      }
    },
    {
      "date": "2027-01-06",
      "event": "",
      "otbRooms": 12,
      "otbRevenue": 1548,
      "stlyRooms": 11,
      "stlyRevenue": 1430,
      "forecastRooms": 92,
      "bar": 141,
      "channels": {
        "Brand.com": {
          "ty": 4,
          "stly": 3
        },
        "Booking.com": {
          "ty": 3,
          "stly": 3
        },
        "Expedia": {
          "ty": 2,
          "stly": 2
        }
      }
    },
    {
      "date": "2027-01-07",
      "event": "",
      "otbRooms": 14,
      "otbRevenue": 1624,
      "stlyRooms": 14,
      "stlyRevenue": 1708,
      "forecastRooms": 93,
      "bar": 140,
      "channels": {
        "Brand.com": {
          "ty": 5,
          "stly": 4
        },
        "Booking.com": {
          "ty": 4,
          "stly": 4
        },
        "Expedia": {
          "ty": 3,
          "stly": 3
        }
      }
    },
    {
      "date": "2027-01-08",
      "event": "",
      "otbRooms": 11,
      "otbRevenue": 1474,
      "stlyRooms": 9,
      "stlyRevenue": 1251,
      "forecastRooms": 93,
      "bar": 154,
      "channels": {
        "Brand.com": {
          "ty": 5,
          "stly": 3
        },
        "Booking.com": {
          "ty": 2,
          "stly": 2
        },
        "Expedia": {
          "ty": 3,
          "stly": 2
        }
      }
    },
    {
      "date": "2027-01-09",
      "event": "",
      "otbRooms": 14,
      "otbRevenue": 1848,
      "stlyRooms": 11,
      "stlyRevenue": 1518,
      "forecastRooms": 106,
      "bar": 145,
      "channels": {
        "Brand.com": {
          "ty": 6,
          "stly": 4
        },
        "Booking.com": {
          "ty": 4,
          "stly": 3
        },
        "Expedia": {
          "ty": 3,
          "stly": 2
        }
      }
    },
    {
      "date": "2027-01-10",
      "event": "",
      "otbRooms": 9,
      "otbRevenue": 936,
      "stlyRooms": 9,
      "stlyRevenue": 990,
      "forecastRooms": 66,
      "bar": 120,
      "channels": {
        "Brand.com": {
          "ty": 4,
          "stly": 3
        },
        "Booking.com": {
          "ty": 2,
          "stly": 2
        },
        "Expedia": {
          "ty": 2,
          "stly": 2
        }
      }
    },
    {
      "date": "2027-01-11",
      "event": "",
      "otbRooms": 10,
      "otbRevenue": 1170,
      "stlyRooms": 6,
      "stlyRevenue": 720,
      "forecastRooms": 82,
      "bar": 138,
      "channels": {
        "Brand.com": {
          "ty": 4,
          "stly": 2
        },
        "Booking.com": {
          "ty": 3,
          "stly": 2
        },
        "Expedia": {
          "ty": 2,
          "stly": 1
        }
      }
    },
    {
      "date": "2027-01-12",
      "event": "",
      "otbRooms": 8,
      "otbRevenue": 952,
      "stlyRooms": 9,
      "stlyRevenue": 1206,
      "forecastRooms": 78,
      "bar": 140,
      "channels": {
        "Brand.com": {
          "ty": 2,
          "stly": 3
        },
        "Booking.com": {
          "ty": 2,
          "stly": 3
        },
        "Expedia": {
          "ty": 1,
          "stly": 2
        }
      }
    },
    {
      "date": "2027-01-13",
      "event": "",
      "otbRooms": 10,
      "otbRevenue": 1280,
      "stlyRooms": 10,
      "stlyRevenue": 1270,
      "forecastRooms": 88,
      "bar": 141,
      "channels": {
        "Brand.com": {
          "ty": 4,
          "stly": 3
        },
        "Booking.com": {
          "ty": 3,
          "stly": 3
        },
        "Expedia": {
          "ty": 2,
          "stly": 2
        }
      }
    },
    {
      "date": "2027-01-14",
      "event": "",
      "otbRooms": 9,
      "otbRevenue": 1143,
      "stlyRooms": 9,
      "stlyRevenue": 1080,
      "forecastRooms": 84,
      "bar": 140,
      "channels": {
        "Brand.com": {
          "ty": 3,
          "stly": 3
        },
        "Booking.com": {
          "ty": 2,
          "stly": 3
        },
        "Expedia": {
          "ty": 1,
          "stly": 2
        }
      }
    },
    {
      "date": "2027-01-15",
      "event": "",
      "otbRooms": 9,
      "otbRevenue": 1233,
      "stlyRooms": 9,
      "stlyRevenue": 1215,
      "forecastRooms": 95,
      "bar": 154,
      "channels": {
        "Brand.com": {
          "ty": 4,
          "stly": 3
        },
        "Booking.com": {
          "ty": 2,
          "stly": 2
        },
        "Expedia": {
          "ty": 1,
          "stly": 1
        }
      }
    },
    {
      "date": "2027-01-16",
      "event": "",
      "otbRooms": 9,
      "otbRevenue": 1323,
      "stlyRooms": 11,
      "stlyRevenue": 1617,
      "forecastRooms": 101,
      "bar": 157,
      "channels": {
        "Brand.com": {
          "ty": 3,
          "stly": 4
        },
        "Booking.com": {
          "ty": 2,
          "stly": 4
        },
        "Expedia": {
          "ty": 1,
          "stly": 2
        }
      }
    },
    {
      "date": "2027-01-17",
      "event": "",
      "otbRooms": 6,
      "otbRevenue": 618,
      "stlyRooms": 6,
      "stlyRevenue": 672,
      "forecastRooms": 68,
      "bar": 120,
      "channels": {
        "Brand.com": {
          "ty": 2,
          "stly": 2
        },
        "Booking.com": {
          "ty": 2,
          "stly": 2
        },
        "Expedia": {
          "ty": 1,
          "stly": 1
        }
      }
    },
    {
      "date": "2027-01-18",
      "event": "",
      "otbRooms": 7,
      "otbRevenue": 882,
      "stlyRooms": 6,
      "stlyRevenue": 750,
      "forecastRooms": 73,
      "bar": 138,
      "channels": {
        "Brand.com": {
          "ty": 1,
          "stly": 1
        },
        "Booking.com": {
          "ty": 2,
          "stly": 2
        },
        "Expedia": {
          "ty": 1,
          "stly": 1
        }
      }
    },
    {
      "date": "2027-01-19",
      "event": "",
      "otbRooms": 7,
      "otbRevenue": 882,
      "stlyRooms": 7,
      "stlyRevenue": 861,
      "forecastRooms": 90,
      "bar": 140,
      "channels": {
        "Brand.com": {
          "ty": 2,
          "stly": 2
        },
        "Booking.com": {
          "ty": 2,
          "stly": 2
        },
        "Expedia": {
          "ty": 1,
          "stly": 1
        }
      }
    },
    {
      "date": "2027-01-20",
      "event": "",
      "otbRooms": 8,
      "otbRevenue": 1000,
      "stlyRooms": 7,
      "stlyRevenue": 903,
      "forecastRooms": 95,
      "bar": 141,
      "channels": {
        "Brand.com": {
          "ty": 3,
          "stly": 2
        },
        "Booking.com": {
          "ty": 2,
          "stly": 2
        },
        "Expedia": {
          "ty": 1,
          "stly": 1
        }
      }
    },
    {
      "date": "2027-01-21",
      "event": "",
      "otbRooms": 7,
      "otbRevenue": 833,
      "stlyRooms": 6,
      "stlyRevenue": 690,
      "forecastRooms": 86,
      "bar": 140,
      "channels": {
        "Brand.com": {
          "ty": 2,
          "stly": 1
        },
        "Booking.com": {
          "ty": 2,
          "stly": 2
        },
        "Expedia": {
          "ty": 1,
          "stly": 1
        }
      }
    },
    {
      "date": "2027-01-22",
      "event": "",
      "otbRooms": 8,
      "otbRevenue": 1192,
      "stlyRooms": 10,
      "stlyRevenue": 1460,
      "forecastRooms": 105,
      "bar": 154,
      "channels": {
        "Brand.com": {
          "ty": 3,
          "stly": 3
        },
        "Booking.com": {
          "ty": 2,
          "stly": 3
        },
        "Expedia": {
          "ty": 2,
          "stly": 2
        }
      }
    },
    {
      "date": "2027-01-23",
      "event": "",
      "otbRooms": 8,
      "otbRevenue": 1032,
      "stlyRooms": 8,
      "stlyRevenue": 1064,
      "forecastRooms": 108,
      "bar": 157,
      "channels": {
        "Brand.com": {
          "ty": 3,
          "stly": 2
        },
        "Booking.com": {
          "ty": 2,
          "stly": 2
        },
        "Expedia": {
          "ty": 2,
          "stly": 2
        }
      }
    },
    {
      "date": "2027-01-24",
      "event": "",
      "otbRooms": 6,
      "otbRevenue": 666,
      "stlyRooms": 6,
      "stlyRevenue": 624,
      "forecastRooms": 66,
      "bar": 120,
      "channels": {
        "Brand.com": {
          "ty": 2,
          "stly": 2
        },
        "Booking.com": {
          "ty": 1,
          "stly": 1
        },
        "Expedia": {
          "ty": 1,
          "stly": 1
        }
      }
    },
    {
      "date": "2027-01-25",
      "event": "",
      "otbRooms": 6,
      "otbRevenue": 768,
      "stlyRooms": 7,
      "stlyRevenue": 847,
      "forecastRooms": 86,
      "bar": 138,
      "channels": {
        "Brand.com": {
          "ty": 2,
          "stly": 2
        },
        "Booking.com": {
          "ty": 2,
          "stly": 2
        },
        "Expedia": {
          "ty": 1,
          "stly": 1
        }
      }
    },
    {
      "date": "2027-01-26",
      "event": "",
      "otbRooms": 7,
      "otbRevenue": 910,
      "stlyRooms": 5,
      "stlyRevenue": 615,
      "forecastRooms": 85,
      "bar": 140,
      "channels": {
        "Brand.com": {
          "ty": 2,
          "stly": 1
        },
        "Booking.com": {
          "ty": 1,
          "stly": 1
        },
        "Expedia": {
          "ty": 1,
          "stly": 1
        }
      }
    },
    {
      "date": "2027-01-27",
      "event": "",
      "otbRooms": 6,
      "otbRevenue": 732,
      "stlyRooms": 7,
      "stlyRevenue": 917,
      "forecastRooms": 95,
      "bar": 141,
      "channels": {
        "Brand.com": {
          "ty": 2,
          "stly": 2
        },
        "Booking.com": {
          "ty": 2,
          "stly": 2
        },
        "Expedia": {
          "ty": 1,
          "stly": 1
        }
      }
    },
    {
      "date": "2027-01-28",
      "event": "",
      "otbRooms": 5,
      "otbRevenue": 650,
      "stlyRooms": 6,
      "stlyRevenue": 792,
      "forecastRooms": 80,
      "bar": 140,
      "channels": {
        "Brand.com": {
          "ty": 1,
          "stly": 2
        },
        "Booking.com": {
          "ty": 1,
          "stly": 2
        },
        "Expedia": {
          "ty": 0,
          "stly": 1
        }
      }
    },
    {
      "date": "2027-01-29",
      "event": "",
      "otbRooms": 7,
      "otbRevenue": 952,
      "stlyRooms": 6,
      "stlyRevenue": 840,
      "forecastRooms": 106,
      "bar": 154,
      "channels": {
        "Brand.com": {
          "ty": 1,
          "stly": 1
        },
        "Booking.com": {
          "ty": 2,
          "stly": 2
        },
        "Expedia": {
          "ty": 1,
          "stly": 1
        }
      }
    },
    {
      "date": "2027-01-30",
      "event": "",
      "otbRooms": 6,
      "otbRevenue": 840,
      "stlyRooms": 5,
      "stlyRevenue": 690,
      "forecastRooms": 95,
      "bar": 157,
      "channels": {
        "Brand.com": {
          "ty": 1,
          "stly": 1
        },
        "Booking.com": {
          "ty": 1,
          "stly": 1
        },
        "Expedia": {
          "ty": 1,
          "stly": 1
        }
      }
    },
    {
      "date": "2027-01-31",
      "event": "",
      "otbRooms": 5,
      "otbRevenue": 530,
      "stlyRooms": 3,
      "stlyRevenue": 315,
      "forecastRooms": 68,
      "bar": 120,
      "channels": {
        "Brand.com": {
          "ty": 1,
          "stly": 1
        },
        "Booking.com": {
          "ty": 1,
          "stly": 1
        },
        "Expedia": {
          "ty": 1,
          "stly": 1
        }
      }
    }
  ],
  "promotions": [
    {
      "id": "P-101",
      "name": "Genius member discount",
      "channel": "Booking.com",
      "type": "Member-only",
      "discountPct": 0.1,
      "extraFeePct": 0,
      "packageCost": 0,
      "stayStart": "2026-10-01",
      "stayEnd": "2026-12-31",
      "bookStart": "2026-09-01",
      "bookEnd": "2026-12-31",
      "minLeadDays": 0,
      "maxLeadDays": 999,
      "stackable": true,
      "fenced": true,
      "status": "Live",
      "launchDate": "2026-09-01",
      "source": "Scraper",
      "promoShare": 0.3,
      "targetRoomNights": 120
    },
    {
      "id": "P-102",
      "name": "Mobile rate",
      "channel": "Booking.com",
      "type": "Mobile",
      "discountPct": 0.25,
      "extraFeePct": 0,
      "packageCost": 0,
      "stayStart": "2026-10-01",
      "stayEnd": "2027-01-31",
      "bookStart": "2026-09-10",
      "bookEnd": "2027-01-31",
      "minLeadDays": 0,
      "maxLeadDays": 999,
      "stackable": false,
      "fenced": true,
      "status": "Live",
      "launchDate": "2026-09-10",
      "source": "Scraper",
      "promoShare": 0.15,
      "targetRoomNights": 60
    },
    {
      "id": "P-103",
      "name": "Early booker deal",
      "channel": "Booking.com",
      "type": "Early booker",
      "discountPct": 0.2,
      "extraFeePct": 0,
      "packageCost": 0,
      "stayStart": "2026-11-15",
      "stayEnd": "2027-01-31",
      "bookStart": "2026-09-15",
      "bookEnd": "2027-01-01",
      "minLeadDays": 30,
      "maxLeadDays": 999,
      "stackable": false,
      "fenced": false,
      "status": "Live",
      "launchDate": "2026-09-15",
      "source": "RM",
      "promoShare": 0.12,
      "targetRoomNights": 40
    },
    {
      "id": "P-104",
      "name": "Member Only Deal",
      "channel": "Expedia",
      "type": "Member-only",
      "discountPct": 0.1,
      "extraFeePct": 0,
      "packageCost": 0,
      "stayStart": "2026-10-01",
      "stayEnd": "2026-11-30",
      "bookStart": "2026-09-01",
      "bookEnd": "2026-11-30",
      "minLeadDays": 0,
      "maxLeadDays": 999,
      "stackable": false,
      "fenced": true,
      "status": "Live",
      "launchDate": "2026-09-01",
      "source": "Scraper",
      "promoShare": 0.3,
      "targetRoomNights": 70
    },
    {
      "id": "P-105",
      "name": "Same-day and last-minute deal",
      "channel": "Expedia",
      "type": "Last-minute",
      "discountPct": 0.15,
      "extraFeePct": 0,
      "packageCost": 0,
      "stayStart": "2026-10-01",
      "stayEnd": "2027-01-31",
      "bookStart": "2026-09-20",
      "bookEnd": "2027-01-31",
      "minLeadDays": 0,
      "maxLeadDays": 3,
      "stackable": false,
      "fenced": false,
      "status": "Live",
      "launchDate": "2026-09-20",
      "source": "Scraper",
      "promoShare": 0.1,
      "targetRoomNights": 15
    },
    {
      "id": "P-106",
      "name": "Accelerator visibility boost",
      "channel": "Expedia",
      "type": "Visibility",
      "discountPct": 0,
      "extraFeePct": 0.05,
      "packageCost": 0,
      "stayStart": "2026-10-12",
      "stayEnd": "2026-10-31",
      "bookStart": "2026-09-15",
      "bookEnd": "2026-10-31",
      "minLeadDays": 0,
      "maxLeadDays": 999,
      "stackable": false,
      "fenced": true,
      "status": "Live",
      "launchDate": "2026-09-15",
      "source": "RM",
      "promoShare": 1,
      "targetRoomNights": 25
    },
    {
      "id": "P-107",
      "name": "Loyalty member rate",
      "channel": "Brand.com",
      "type": "Member-only",
      "discountPct": 0.1,
      "extraFeePct": 0.03,
      "packageCost": 0,
      "stayStart": "2026-10-01",
      "stayEnd": "2027-01-31",
      "bookStart": "2026-09-01",
      "bookEnd": "2027-01-31",
      "minLeadDays": 0,
      "maxLeadDays": 999,
      "stackable": false,
      "fenced": true,
      "status": "Live",
      "launchDate": "2026-09-01",
      "source": "RM",
      "promoShare": 0.25,
      "targetRoomNights": 90
    },
    {
      "id": "P-108",
      "name": "Stay longer and save, breakfast included",
      "channel": "Brand.com",
      "type": "Value-add",
      "discountPct": 0,
      "extraFeePct": 0,
      "packageCost": 18,
      "stayStart": "2026-11-01",
      "stayEnd": "2026-12-20",
      "bookStart": "2026-10-05",
      "bookEnd": "2026-12-20",
      "minLeadDays": 0,
      "maxLeadDays": 999,
      "stackable": false,
      "fenced": true,
      "status": "Planned",
      "launchDate": "2026-10-05",
      "source": "RM",
      "promoShare": 0.1,
      "targetRoomNights": 30
    },
    {
      "id": "P-109",
      "name": "Holiday getaway deal",
      "channel": "Booking.com",
      "type": "Seasonal",
      "discountPct": 0.2,
      "extraFeePct": 0,
      "packageCost": 0,
      "stayStart": "2026-12-26",
      "stayEnd": "2027-01-10",
      "bookStart": "2026-10-10",
      "bookEnd": "2027-01-10",
      "minLeadDays": 0,
      "maxLeadDays": 999,
      "stackable": false,
      "fenced": false,
      "status": "Planned",
      "launchDate": "2026-10-10",
      "source": "RM",
      "promoShare": 0.15,
      "targetRoomNights": 35
    },
    {
      "id": "P-110",
      "name": "Early booking discount",
      "channel": "Expedia",
      "type": "Early booker",
      "discountPct": 0.12,
      "extraFeePct": 0,
      "packageCost": 0,
      "stayStart": "2027-01-05",
      "stayEnd": "2027-01-31",
      "bookStart": "2026-09-15",
      "bookEnd": "2027-01-01",
      "minLeadDays": 30,
      "maxLeadDays": 999,
      "stackable": false,
      "fenced": false,
      "status": "Paused",
      "launchDate": "2026-09-15",
      "source": "RM",
      "promoShare": 0.1,
      "targetRoomNights": 20
    }
  ],
  "bookings": [
    {
      "confirmation": "BK1000019",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-04",
      "bookedDate": "2026-09-03",
      "roomType": "Double Queen",
      "rate": 117,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1000042",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-04",
      "bookedDate": "2026-09-17",
      "roomType": "King",
      "rate": 118,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1000084",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-04",
      "bookedDate": "2026-09-14",
      "roomType": "King",
      "rate": 117,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1000131",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-04",
      "bookedDate": "2026-09-02",
      "roomType": "King Suite",
      "rate": 141,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1000198",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-04",
      "bookedDate": "2026-09-13",
      "roomType": "Double Queen",
      "rate": 119,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1000285",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-04",
      "bookedDate": "2026-09-28",
      "roomType": "Double Queen",
      "rate": 121,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1000019",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-05",
      "bookedDate": "2026-09-03",
      "roomType": "Double Queen",
      "rate": 140,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1000042",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-05",
      "bookedDate": "2026-09-17",
      "roomType": "King",
      "rate": 140,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1000084",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-05",
      "bookedDate": "2026-09-14",
      "roomType": "King",
      "rate": 139,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1000131",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-05",
      "bookedDate": "2026-09-02",
      "roomType": "King Suite",
      "rate": 166,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1000198",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-05",
      "bookedDate": "2026-09-13",
      "roomType": "Double Queen",
      "rate": 141,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1000285",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-05",
      "bookedDate": "2026-09-28",
      "roomType": "Double Queen",
      "rate": 146,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1000381",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-05",
      "bookedDate": "2026-09-09",
      "roomType": "King",
      "rate": 139,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1000416",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-05",
      "bookedDate": "2026-09-28",
      "roomType": "King",
      "rate": 145,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1000504",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-05",
      "bookedDate": "2026-09-19",
      "roomType": "Double Queen",
      "rate": 139,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1000548",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-05",
      "bookedDate": "2026-09-16",
      "roomType": "King",
      "rate": 140,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1000574",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-05",
      "bookedDate": "2026-09-01",
      "roomType": "King",
      "rate": 141,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1000660",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-05",
      "bookedDate": "2026-09-13",
      "roomType": "King",
      "rate": 139,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1000674",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-05",
      "bookedDate": "2026-09-10",
      "roomType": "King",
      "rate": 139,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1000715",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-05",
      "bookedDate": "2026-09-15",
      "roomType": "King",
      "rate": 145,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1000737",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-05",
      "bookedDate": "2026-09-25",
      "roomType": "Double Queen",
      "rate": 142,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1000776",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-05",
      "bookedDate": "2026-09-10",
      "roomType": "King",
      "rate": 145,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1000019",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-06",
      "bookedDate": "2026-09-03",
      "roomType": "Double Queen",
      "rate": 135,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1000042",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-06",
      "bookedDate": "2026-09-17",
      "roomType": "King",
      "rate": 139,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1000084",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-06",
      "bookedDate": "2026-09-14",
      "roomType": "King",
      "rate": 139,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1000381",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-06",
      "bookedDate": "2026-09-09",
      "roomType": "King",
      "rate": 140,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1000416",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-06",
      "bookedDate": "2026-09-28",
      "roomType": "King",
      "rate": 139,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1000504",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-06",
      "bookedDate": "2026-09-19",
      "roomType": "Double Queen",
      "rate": 139,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1000843",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-06",
      "bookedDate": "2026-09-09",
      "roomType": "King Suite",
      "rate": 163,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1000848",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-06",
      "bookedDate": "2026-09-15",
      "roomType": "King",
      "rate": 139,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1000899",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-06",
      "bookedDate": "2026-09-29",
      "roomType": "Double Queen",
      "rate": 139,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1000964",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-06",
      "bookedDate": "2026-09-17",
      "roomType": "King",
      "rate": 140,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1001035",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-06",
      "bookedDate": "2026-09-06",
      "roomType": "Double Queen",
      "rate": 140,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1001101",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-06",
      "bookedDate": "2026-09-25",
      "roomType": "King",
      "rate": 136,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1001183",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-06",
      "bookedDate": "2026-09-09",
      "roomType": "King",
      "rate": 136,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1000843",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-07",
      "bookedDate": "2026-09-09",
      "roomType": "King Suite",
      "rate": 163,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1000848",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-07",
      "bookedDate": "2026-09-15",
      "roomType": "King",
      "rate": 138,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1000899",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-07",
      "bookedDate": "2026-09-29",
      "roomType": "Double Queen",
      "rate": 137,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1001272",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-07",
      "bookedDate": "2026-10-02",
      "roomType": "King",
      "rate": 140,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1001290",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-07",
      "bookedDate": "2026-09-13",
      "roomType": "King",
      "rate": 140,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1001350",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-07",
      "bookedDate": "2026-09-18",
      "roomType": "King",
      "rate": 144,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1001386",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-07",
      "bookedDate": "2026-09-24",
      "roomType": "King",
      "rate": 141,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1001479",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-07",
      "bookedDate": "2026-09-24",
      "roomType": "King",
      "rate": 140,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1001539",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-07",
      "bookedDate": "2026-09-26",
      "roomType": "King",
      "rate": 139,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1001272",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-08",
      "bookedDate": "2026-10-02",
      "roomType": "King",
      "rate": 127,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1001290",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-08",
      "bookedDate": "2026-09-13",
      "roomType": "King",
      "rate": 129,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1001542",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-08",
      "bookedDate": "2026-09-21",
      "roomType": "Double Queen",
      "rate": 127,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1001636",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-08",
      "bookedDate": "2026-09-01",
      "roomType": "King Suite",
      "rate": 154,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1001714",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-08",
      "bookedDate": "2026-09-05",
      "roomType": "King",
      "rate": 128,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1001753",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-08",
      "bookedDate": "2026-09-10",
      "roomType": "King",
      "rate": 130,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1001759",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-08",
      "bookedDate": "2026-09-26",
      "roomType": "King Suite",
      "rate": 155,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1001768",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-08",
      "bookedDate": "2026-09-27",
      "roomType": "Double Queen",
      "rate": 131,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1001272",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-09",
      "bookedDate": "2026-10-02",
      "roomType": "King",
      "rate": 151,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1001542",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-09",
      "bookedDate": "2026-09-21",
      "roomType": "Double Queen",
      "rate": 155,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1001636",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-09",
      "bookedDate": "2026-09-01",
      "roomType": "King Suite",
      "rate": 177,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1001714",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-09",
      "bookedDate": "2026-09-05",
      "roomType": "King",
      "rate": 151,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1001854",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-09",
      "bookedDate": "2026-09-17",
      "roomType": "King",
      "rate": 152,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1001872",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-09",
      "bookedDate": "2026-09-11",
      "roomType": "Double Queen",
      "rate": 152,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1001945",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-09",
      "bookedDate": "2026-09-15",
      "roomType": "Double Queen",
      "rate": 154,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1002018",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-09",
      "bookedDate": "2026-09-13",
      "roomType": "King",
      "rate": 153,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1001542",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-10",
      "bookedDate": "2026-09-21",
      "roomType": "Double Queen",
      "rate": 148,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1001636",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-10",
      "bookedDate": "2026-09-01",
      "roomType": "King Suite",
      "rate": 180,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1001714",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-10",
      "bookedDate": "2026-09-05",
      "roomType": "King",
      "rate": 154,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1001854",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-10",
      "bookedDate": "2026-09-17",
      "roomType": "King",
      "rate": 152,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1002070",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-10",
      "bookedDate": "2026-09-27",
      "roomType": "Double Queen",
      "rate": 150,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1002136",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-10",
      "bookedDate": "2026-09-18",
      "roomType": "Double Queen",
      "rate": 153,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1002166",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-10",
      "bookedDate": "2026-09-06",
      "roomType": "King",
      "rate": 151,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1002208",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-10",
      "bookedDate": "2026-09-02",
      "roomType": "King",
      "rate": 153,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1002286",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-10",
      "bookedDate": "2026-10-02",
      "roomType": "King",
      "rate": 155,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1002348",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-10",
      "bookedDate": "2026-09-29",
      "roomType": "King",
      "rate": 149,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1002438",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-10",
      "bookedDate": "2026-09-07",
      "roomType": "King Suite",
      "rate": 177,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1002499",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-10",
      "bookedDate": "2026-09-06",
      "roomType": "Double Queen",
      "rate": 153,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1002540",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-10",
      "bookedDate": "2026-09-09",
      "roomType": "Double Queen",
      "rate": 151,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1002555",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-10",
      "bookedDate": "2026-09-05",
      "roomType": "King",
      "rate": 149,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1002593",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-10",
      "bookedDate": "2026-09-21",
      "roomType": "Double Queen",
      "rate": 151,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1001542",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-11",
      "bookedDate": "2026-09-21",
      "roomType": "Double Queen",
      "rate": 122,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1002070",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-11",
      "bookedDate": "2026-09-27",
      "roomType": "Double Queen",
      "rate": 118,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1002136",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-11",
      "bookedDate": "2026-09-18",
      "roomType": "Double Queen",
      "rate": 117,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1002635",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-11",
      "bookedDate": "2026-09-04",
      "roomType": "King",
      "rate": 120,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1002670",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-11",
      "bookedDate": "2026-09-15",
      "roomType": "Double Queen",
      "rate": 117,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1002760",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-11",
      "bookedDate": "2026-09-26",
      "roomType": "King",
      "rate": 121,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1002789",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-11",
      "bookedDate": "2026-10-02",
      "roomType": "King Suite",
      "rate": 146,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1001542",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-12",
      "bookedDate": "2026-09-21",
      "roomType": "Double Queen",
      "rate": 139,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1002635",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-12",
      "bookedDate": "2026-09-04",
      "roomType": "King",
      "rate": 133,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1002670",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-12",
      "bookedDate": "2026-09-15",
      "roomType": "Double Queen",
      "rate": 134,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1002815",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-12",
      "bookedDate": "2026-09-15",
      "roomType": "Double Queen",
      "rate": 133,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1002868",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-12",
      "bookedDate": "2026-09-04",
      "roomType": "King",
      "rate": 134,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1002962",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-12",
      "bookedDate": "2026-09-21",
      "roomType": "Double Queen",
      "rate": 139,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1003024",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-12",
      "bookedDate": "2026-09-03",
      "roomType": "King",
      "rate": 138,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1003083",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-12",
      "bookedDate": "2026-09-11",
      "roomType": "King",
      "rate": 133,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1003101",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-12",
      "bookedDate": "2026-09-14",
      "roomType": "King",
      "rate": 135,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1003115",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-12",
      "bookedDate": "2026-09-04",
      "roomType": "Double Queen",
      "rate": 136,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1001542",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-13",
      "bookedDate": "2026-09-21",
      "roomType": "Double Queen",
      "rate": 140,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1002635",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-13",
      "bookedDate": "2026-09-04",
      "roomType": "King",
      "rate": 140,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1002815",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-13",
      "bookedDate": "2026-09-15",
      "roomType": "Double Queen",
      "rate": 139,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1002868",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-13",
      "bookedDate": "2026-09-04",
      "roomType": "King",
      "rate": 138,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1003198",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-13",
      "bookedDate": "2026-09-27",
      "roomType": "King",
      "rate": 138,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1003208",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-13",
      "bookedDate": "2026-09-17",
      "roomType": "King",
      "rate": 140,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1003216",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-13",
      "bookedDate": "2026-09-17",
      "roomType": "Double Queen",
      "rate": 142,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1003300",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-13",
      "bookedDate": "2026-09-05",
      "roomType": "King",
      "rate": 139,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1001542",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-14",
      "bookedDate": "2026-09-21",
      "roomType": "Double Queen",
      "rate": 139,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1002635",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-14",
      "bookedDate": "2026-09-04",
      "roomType": "King",
      "rate": 139,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1002815",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-14",
      "bookedDate": "2026-09-15",
      "roomType": "Double Queen",
      "rate": 138,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1002868",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-14",
      "bookedDate": "2026-09-04",
      "roomType": "King",
      "rate": 139,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1003198",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-14",
      "bookedDate": "2026-09-27",
      "roomType": "King",
      "rate": 143,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1003208",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-14",
      "bookedDate": "2026-09-17",
      "roomType": "King",
      "rate": 144,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1003216",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-14",
      "bookedDate": "2026-09-17",
      "roomType": "Double Queen",
      "rate": 140,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1003300",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-14",
      "bookedDate": "2026-09-05",
      "roomType": "King",
      "rate": 143,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1003352",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-14",
      "bookedDate": "2026-09-17",
      "roomType": "King Suite",
      "rate": 163,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1003356",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-14",
      "bookedDate": "2026-09-20",
      "roomType": "Double Queen",
      "rate": 141,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1003390",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-14",
      "bookedDate": "2026-09-27",
      "roomType": "King",
      "rate": 141,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1003402",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-14",
      "bookedDate": "2026-09-17",
      "roomType": "Double Queen",
      "rate": 140,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1003462",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-14",
      "bookedDate": "2026-09-12",
      "roomType": "King",
      "rate": 141,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1003533",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-14",
      "bookedDate": "2026-09-08",
      "roomType": "Double Queen",
      "rate": 139,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1003560",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-14",
      "bookedDate": "2026-09-21",
      "roomType": "King",
      "rate": 139,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1001542",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-15",
      "bookedDate": "2026-09-21",
      "roomType": "Double Queen",
      "rate": 136,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1003352",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-15",
      "bookedDate": "2026-09-17",
      "roomType": "King Suite",
      "rate": 166,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1003356",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-15",
      "bookedDate": "2026-09-20",
      "roomType": "Double Queen",
      "rate": 137,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1003575",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-15",
      "bookedDate": "2026-09-30",
      "roomType": "King Suite",
      "rate": 163,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1003635",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-15",
      "bookedDate": "2026-09-24",
      "roomType": "King",
      "rate": 135,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1003647",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-15",
      "bookedDate": "2026-09-24",
      "roomType": "Double Queen",
      "rate": 139,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1003735",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-15",
      "bookedDate": "2026-09-01",
      "roomType": "King",
      "rate": 139,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1003352",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-16",
      "bookedDate": "2026-09-17",
      "roomType": "King Suite",
      "rate": 168,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1003575",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-16",
      "bookedDate": "2026-09-30",
      "roomType": "King Suite",
      "rate": 168,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1003635",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-16",
      "bookedDate": "2026-09-24",
      "roomType": "King",
      "rate": 139,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1003821",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-16",
      "bookedDate": "2026-09-14",
      "roomType": "Double Queen",
      "rate": 142,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1003885",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-16",
      "bookedDate": "2026-09-05",
      "roomType": "King",
      "rate": 144,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1003938",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-16",
      "bookedDate": "2026-09-18",
      "roomType": "King",
      "rate": 141,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1003980",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-16",
      "bookedDate": "2026-09-23",
      "roomType": "King",
      "rate": 144,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1004065",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-16",
      "bookedDate": "2026-09-13",
      "roomType": "King",
      "rate": 146,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1004088",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-16",
      "bookedDate": "2026-09-28",
      "roomType": "King",
      "rate": 143,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1003575",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-17",
      "bookedDate": "2026-09-30",
      "roomType": "King Suite",
      "rate": 163,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1003635",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-17",
      "bookedDate": "2026-09-24",
      "roomType": "King",
      "rate": 136,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1003821",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-17",
      "bookedDate": "2026-09-14",
      "roomType": "Double Queen",
      "rate": 137,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1004107",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-17",
      "bookedDate": "2026-09-01",
      "roomType": "King",
      "rate": 141,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1004183",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-17",
      "bookedDate": "2026-09-24",
      "roomType": "Double Queen",
      "rate": 138,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1004211",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-17",
      "bookedDate": "2026-09-20",
      "roomType": "King",
      "rate": 142,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1004220",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-17",
      "bookedDate": "2026-09-25",
      "roomType": "King",
      "rate": 140,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1004304",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-17",
      "bookedDate": "2026-09-15",
      "roomType": "Double Queen",
      "rate": 137,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1004379",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-17",
      "bookedDate": "2026-09-14",
      "roomType": "King",
      "rate": 136,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1003821",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-18",
      "bookedDate": "2026-09-14",
      "roomType": "Double Queen",
      "rate": 119,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1004107",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-18",
      "bookedDate": "2026-09-01",
      "roomType": "King",
      "rate": 119,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1004183",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-18",
      "bookedDate": "2026-09-24",
      "roomType": "Double Queen",
      "rate": 116,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1004406",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-18",
      "bookedDate": "2026-09-03",
      "roomType": "King Suite",
      "rate": 145,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1004450",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-18",
      "bookedDate": "2026-09-08",
      "roomType": "King",
      "rate": 121,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1004536",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-18",
      "bookedDate": "2026-09-27",
      "roomType": "King",
      "rate": 118,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1004598",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-18",
      "bookedDate": "2026-09-16",
      "roomType": "King",
      "rate": 121,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1004661",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-18",
      "bookedDate": "2026-09-26",
      "roomType": "King",
      "rate": 119,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1004669",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-18",
      "bookedDate": "2026-09-03",
      "roomType": "Double Queen",
      "rate": 120,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1004107",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-19",
      "bookedDate": "2026-09-01",
      "roomType": "King",
      "rate": 136,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1004406",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-19",
      "bookedDate": "2026-09-03",
      "roomType": "King Suite",
      "rate": 158,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1004450",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-19",
      "bookedDate": "2026-09-08",
      "roomType": "King",
      "rate": 139,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1004536",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-19",
      "bookedDate": "2026-09-27",
      "roomType": "King",
      "rate": 138,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1004678",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-19",
      "bookedDate": "2026-10-03",
      "roomType": "King Suite",
      "rate": 163,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1004769",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-19",
      "bookedDate": "2026-09-08",
      "roomType": "King",
      "rate": 136,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1004793",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-19",
      "bookedDate": "2026-09-15",
      "roomType": "King",
      "rate": 138,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1004406",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-20",
      "bookedDate": "2026-09-03",
      "roomType": "King Suite",
      "rate": 163,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1004678",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-20",
      "bookedDate": "2026-10-03",
      "roomType": "King Suite",
      "rate": 161,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1004769",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-20",
      "bookedDate": "2026-09-08",
      "roomType": "King",
      "rate": 141,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1004793",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-20",
      "bookedDate": "2026-09-15",
      "roomType": "King",
      "rate": 140,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1004836",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-20",
      "bookedDate": "2026-09-24",
      "roomType": "King",
      "rate": 136,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1004925",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-20",
      "bookedDate": "2026-09-21",
      "roomType": "King Suite",
      "rate": 165,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1004974",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-20",
      "bookedDate": "2026-09-29",
      "roomType": "Double Queen",
      "rate": 141,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1005027",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-20",
      "bookedDate": "2026-09-24",
      "roomType": "King",
      "rate": 138,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1005052",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-20",
      "bookedDate": "2026-09-04",
      "roomType": "King",
      "rate": 137,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1004406",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-21",
      "bookedDate": "2026-09-03",
      "roomType": "King Suite",
      "rate": 164,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1004678",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-21",
      "bookedDate": "2026-10-03",
      "roomType": "King Suite",
      "rate": 166,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1004769",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-21",
      "bookedDate": "2026-09-08",
      "roomType": "King",
      "rate": 138,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1004836",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-21",
      "bookedDate": "2026-09-24",
      "roomType": "King",
      "rate": 137,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1004925",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-21",
      "bookedDate": "2026-09-21",
      "roomType": "King Suite",
      "rate": 163,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1004974",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-21",
      "bookedDate": "2026-09-29",
      "roomType": "Double Queen",
      "rate": 144,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1005027",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-21",
      "bookedDate": "2026-09-24",
      "roomType": "King",
      "rate": 142,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1005139",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-21",
      "bookedDate": "2026-09-21",
      "roomType": "Double Queen",
      "rate": 139,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1005188",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-21",
      "bookedDate": "2026-09-04",
      "roomType": "King",
      "rate": 142,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1005266",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-21",
      "bookedDate": "2026-09-09",
      "roomType": "King",
      "rate": 140,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1004678",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-22",
      "bookedDate": "2026-10-03",
      "roomType": "King Suite",
      "rate": 155,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1005139",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-22",
      "bookedDate": "2026-09-21",
      "roomType": "Double Queen",
      "rate": 130,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1005188",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-22",
      "bookedDate": "2026-09-04",
      "roomType": "King",
      "rate": 131,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1005320",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-22",
      "bookedDate": "2026-09-17",
      "roomType": "King Suite",
      "rate": 161,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1005399",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-22",
      "bookedDate": "2026-09-29",
      "roomType": "Double Queen",
      "rate": 133,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1005415",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-22",
      "bookedDate": "2026-09-01",
      "roomType": "Double Queen",
      "rate": 131,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1005484",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-22",
      "bookedDate": "2026-10-03",
      "roomType": "Double Queen",
      "rate": 134,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1004678",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-23",
      "bookedDate": "2026-10-03",
      "roomType": "King Suite",
      "rate": 177,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1005139",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-23",
      "bookedDate": "2026-09-21",
      "roomType": "Double Queen",
      "rate": 151,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1005188",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-23",
      "bookedDate": "2026-09-04",
      "roomType": "King",
      "rate": 155,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1005320",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-23",
      "bookedDate": "2026-09-17",
      "roomType": "King Suite",
      "rate": 178,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1005399",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-23",
      "bookedDate": "2026-09-29",
      "roomType": "Double Queen",
      "rate": 150,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1005579",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-23",
      "bookedDate": "2026-10-01",
      "roomType": "Double Queen",
      "rate": 155,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1005641",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-23",
      "bookedDate": "2026-09-06",
      "roomType": "Double Queen",
      "rate": 150,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1005732",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-23",
      "bookedDate": "2026-09-17",
      "roomType": "Double Queen",
      "rate": 153,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1005801",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-23",
      "bookedDate": "2026-09-17",
      "roomType": "King",
      "rate": 155,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1005139",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-24",
      "bookedDate": "2026-09-21",
      "roomType": "Double Queen",
      "rate": 139,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1005320",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-24",
      "bookedDate": "2026-09-17",
      "roomType": "King Suite",
      "rate": 159,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1005399",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-24",
      "bookedDate": "2026-09-29",
      "roomType": "Double Queen",
      "rate": 137,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1005579",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-24",
      "bookedDate": "2026-10-01",
      "roomType": "Double Queen",
      "rate": 139,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1005641",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-24",
      "bookedDate": "2026-09-06",
      "roomType": "Double Queen",
      "rate": 139,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1005828",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-24",
      "bookedDate": "2026-09-25",
      "roomType": "King",
      "rate": 139,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1005919",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-24",
      "bookedDate": "2026-10-01",
      "roomType": "Double Queen",
      "rate": 133,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1005972",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-24",
      "bookedDate": "2026-09-05",
      "roomType": "Double Queen",
      "rate": 133,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1005978",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-24",
      "bookedDate": "2026-09-03",
      "roomType": "King",
      "rate": 133,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1005320",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-25",
      "bookedDate": "2026-09-17",
      "roomType": "King Suite",
      "rate": 146,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1005828",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-25",
      "bookedDate": "2026-09-25",
      "roomType": "King",
      "rate": 117,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1006006",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-25",
      "bookedDate": "2026-09-05",
      "roomType": "King Suite",
      "rate": 145,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1006040",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-25",
      "bookedDate": "2026-09-14",
      "roomType": "King",
      "rate": 122,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1006124",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-25",
      "bookedDate": "2026-09-06",
      "roomType": "Double Queen",
      "rate": 118,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1005320",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-26",
      "bookedDate": "2026-09-17",
      "roomType": "King Suite",
      "rate": 160,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1006006",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-26",
      "bookedDate": "2026-09-05",
      "roomType": "King Suite",
      "rate": 160,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1006040",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-26",
      "bookedDate": "2026-09-14",
      "roomType": "King",
      "rate": 139,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1006129",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-26",
      "bookedDate": "2026-09-23",
      "roomType": "King",
      "rate": 138,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1006196",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-26",
      "bookedDate": "2026-10-01",
      "roomType": "Double Queen",
      "rate": 133,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1006254",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-26",
      "bookedDate": "2026-09-07",
      "roomType": "King",
      "rate": 136,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1005320",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-27",
      "bookedDate": "2026-09-17",
      "roomType": "King Suite",
      "rate": 163,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1006006",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-27",
      "bookedDate": "2026-09-05",
      "roomType": "King Suite",
      "rate": 166,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1006129",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-27",
      "bookedDate": "2026-09-23",
      "roomType": "King",
      "rate": 140,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1006278",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-27",
      "bookedDate": "2026-09-28",
      "roomType": "King",
      "rate": 140,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1006281",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-27",
      "bookedDate": "2026-09-23",
      "roomType": "Double Queen",
      "rate": 140,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1005320",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-28",
      "bookedDate": "2026-09-17",
      "roomType": "King Suite",
      "rate": 169,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1006278",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-28",
      "bookedDate": "2026-09-28",
      "roomType": "King",
      "rate": 142,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1006281",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-28",
      "bookedDate": "2026-09-23",
      "roomType": "Double Queen",
      "rate": 139,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1006298",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-28",
      "bookedDate": "2026-09-06",
      "roomType": "Double Queen",
      "rate": 141,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1006278",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-29",
      "bookedDate": "2026-09-28",
      "roomType": "King",
      "rate": 139,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1006298",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-29",
      "bookedDate": "2026-09-06",
      "roomType": "Double Queen",
      "rate": 137,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1006355",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-29",
      "bookedDate": "2026-09-02",
      "roomType": "King",
      "rate": 137,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1006379",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-29",
      "bookedDate": "2026-09-25",
      "roomType": "King Suite",
      "rate": 166,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1006459",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-29",
      "bookedDate": "2026-09-03",
      "roomType": "King",
      "rate": 136,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1006546",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-29",
      "bookedDate": "2026-09-21",
      "roomType": "King",
      "rate": 140,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1006565",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-29",
      "bookedDate": "2026-09-22",
      "roomType": "Double Queen",
      "rate": 136,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1006647",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-29",
      "bookedDate": "2026-09-10",
      "roomType": "Double Queen",
      "rate": 139,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1006694",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-29",
      "bookedDate": "2026-09-11",
      "roomType": "King",
      "rate": 136,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1006710",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-29",
      "bookedDate": "2026-09-11",
      "roomType": "King Suite",
      "rate": 162,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1006751",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-29",
      "bookedDate": "2026-09-20",
      "roomType": "King",
      "rate": 139,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1006278",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-30",
      "bookedDate": "2026-09-28",
      "roomType": "King",
      "rate": 153,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1006355",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-30",
      "bookedDate": "2026-09-02",
      "roomType": "King",
      "rate": 151,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1006379",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-30",
      "bookedDate": "2026-09-25",
      "roomType": "King Suite",
      "rate": 176,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1006842",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-30",
      "bookedDate": "2026-09-15",
      "roomType": "Double Queen",
      "rate": 152,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1006939",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-30",
      "bookedDate": "2026-09-16",
      "roomType": "King Suite",
      "rate": 178,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1006355",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-31",
      "bookedDate": "2026-09-02",
      "roomType": "King",
      "rate": 149,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1006379",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-31",
      "bookedDate": "2026-09-25",
      "roomType": "King Suite",
      "rate": 172,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1006971",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-31",
      "bookedDate": "2026-09-15",
      "roomType": "Double Queen",
      "rate": 147,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1007065",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-31",
      "bookedDate": "2026-09-11",
      "roomType": "King",
      "rate": 147,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1007120",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-10-31",
      "bookedDate": "2026-09-12",
      "roomType": "King Suite",
      "rate": 169,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1007136",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-01",
      "bookedDate": "2026-09-03",
      "roomType": "King",
      "rate": 116,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1007164",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-01",
      "bookedDate": "2026-09-23",
      "roomType": "King",
      "rate": 115,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1007232",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-01",
      "bookedDate": "2026-09-02",
      "roomType": "Double Queen",
      "rate": 115,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1007293",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-01",
      "bookedDate": "2026-09-14",
      "roomType": "King Suite",
      "rate": 140,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1007136",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-02",
      "bookedDate": "2026-09-03",
      "roomType": "King",
      "rate": 128,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1007164",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-02",
      "bookedDate": "2026-09-23",
      "roomType": "King",
      "rate": 134,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1007232",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-02",
      "bookedDate": "2026-09-02",
      "roomType": "Double Queen",
      "rate": 133,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1007293",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-02",
      "bookedDate": "2026-09-14",
      "roomType": "King Suite",
      "rate": 157,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1007374",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-02",
      "bookedDate": "2026-09-23",
      "roomType": "Double Queen",
      "rate": 130,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1007457",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-02",
      "bookedDate": "2026-09-23",
      "roomType": "Double Queen",
      "rate": 129,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1007527",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-02",
      "bookedDate": "2026-09-15",
      "roomType": "King Suite",
      "rate": 155,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1007136",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-03",
      "bookedDate": "2026-09-03",
      "roomType": "King",
      "rate": 134,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1007374",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-03",
      "bookedDate": "2026-09-23",
      "roomType": "Double Queen",
      "rate": 134,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1007457",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-03",
      "bookedDate": "2026-09-23",
      "roomType": "Double Queen",
      "rate": 132,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1007548",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-03",
      "bookedDate": "2026-09-23",
      "roomType": "Double Queen",
      "rate": 135,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1007588",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-03",
      "bookedDate": "2026-09-09",
      "roomType": "Double Queen",
      "rate": 134,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1007645",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-03",
      "bookedDate": "2026-09-12",
      "roomType": "Double Queen",
      "rate": 135,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1007374",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-04",
      "bookedDate": "2026-09-23",
      "roomType": "Double Queen",
      "rate": 134,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1007548",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-04",
      "bookedDate": "2026-09-23",
      "roomType": "Double Queen",
      "rate": 137,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1007588",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-04",
      "bookedDate": "2026-09-09",
      "roomType": "Double Queen",
      "rate": 133,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1007658",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-04",
      "bookedDate": "2026-09-21",
      "roomType": "Double Queen",
      "rate": 137,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1007662",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-04",
      "bookedDate": "2026-09-01",
      "roomType": "King",
      "rate": 133,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1007739",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-04",
      "bookedDate": "2026-09-10",
      "roomType": "Double Queen",
      "rate": 134,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1007768",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-04",
      "bookedDate": "2026-09-26",
      "roomType": "Double Queen",
      "rate": 137,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1007782",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-04",
      "bookedDate": "2026-09-20",
      "roomType": "King",
      "rate": 135,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1007841",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-04",
      "bookedDate": "2026-09-08",
      "roomType": "Double Queen",
      "rate": 133,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1007862",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-05",
      "bookedDate": "2026-10-02",
      "roomType": "King",
      "rate": 133,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1007885",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-05",
      "bookedDate": "2026-09-21",
      "roomType": "Double Queen",
      "rate": 134,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1007935",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-05",
      "bookedDate": "2026-09-28",
      "roomType": "King",
      "rate": 130,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1008019",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-05",
      "bookedDate": "2026-09-02",
      "roomType": "King",
      "rate": 134,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1008034",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-05",
      "bookedDate": "2026-10-03",
      "roomType": "Double Queen",
      "rate": 130,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1007862",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-06",
      "bookedDate": "2026-10-02",
      "roomType": "King",
      "rate": 145,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1007885",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-06",
      "bookedDate": "2026-09-21",
      "roomType": "Double Queen",
      "rate": 147,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1007935",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-06",
      "bookedDate": "2026-09-28",
      "roomType": "King",
      "rate": 150,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1008053",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-06",
      "bookedDate": "2026-09-22",
      "roomType": "King",
      "rate": 146,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1008126",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-06",
      "bookedDate": "2026-09-14",
      "roomType": "King",
      "rate": 145,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1008053",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-07",
      "bookedDate": "2026-09-22",
      "roomType": "King",
      "rate": 125,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1008144",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-07",
      "bookedDate": "2026-09-22",
      "roomType": "King",
      "rate": 125,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1008158",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-07",
      "bookedDate": "2026-09-03",
      "roomType": "King",
      "rate": 127,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1008212",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-07",
      "bookedDate": "2026-09-20",
      "roomType": "King",
      "rate": 129,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1008299",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-07",
      "bookedDate": "2026-09-04",
      "roomType": "Double Queen",
      "rate": 128,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1008382",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-07",
      "bookedDate": "2026-09-06",
      "roomType": "King",
      "rate": 127,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1008053",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-08",
      "bookedDate": "2026-09-22",
      "roomType": "King",
      "rate": 113,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1008144",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-08",
      "bookedDate": "2026-09-22",
      "roomType": "King",
      "rate": 116,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1008468",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-08",
      "bookedDate": "2026-09-01",
      "roomType": "King",
      "rate": 116,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1008053",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-09",
      "bookedDate": "2026-09-22",
      "roomType": "King",
      "rate": 129,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1008144",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-09",
      "bookedDate": "2026-09-22",
      "roomType": "King",
      "rate": 131,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1008468",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-09",
      "bookedDate": "2026-09-01",
      "roomType": "King",
      "rate": 128,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1008511",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-09",
      "bookedDate": "2026-09-02",
      "roomType": "King",
      "rate": 134,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1008567",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-09",
      "bookedDate": "2026-09-26",
      "roomType": "King",
      "rate": 130,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1008589",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-10",
      "bookedDate": "2026-10-01",
      "roomType": "Double Queen",
      "rate": 130,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1008611",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-10",
      "bookedDate": "2026-09-01",
      "roomType": "King",
      "rate": 134,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1008625",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-10",
      "bookedDate": "2026-09-14",
      "roomType": "Double Queen",
      "rate": 129,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1008659",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-10",
      "bookedDate": "2026-09-29",
      "roomType": "Double Queen",
      "rate": 130,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1008753",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-10",
      "bookedDate": "2026-09-10",
      "roomType": "Double Queen",
      "rate": 133,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1008814",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-10",
      "bookedDate": "2026-09-17",
      "roomType": "King Suite",
      "rate": 154,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1008589",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-11",
      "bookedDate": "2026-10-01",
      "roomType": "Double Queen",
      "rate": 136,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1008904",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-11",
      "bookedDate": "2026-09-06",
      "roomType": "King",
      "rate": 135,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1008969",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-11",
      "bookedDate": "2026-09-04",
      "roomType": "King",
      "rate": 136,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1008993",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-11",
      "bookedDate": "2026-09-10",
      "roomType": "King Suite",
      "rate": 162,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1008904",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-12",
      "bookedDate": "2026-09-06",
      "roomType": "King",
      "rate": 136,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1008969",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-12",
      "bookedDate": "2026-09-04",
      "roomType": "King",
      "rate": 135,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1009053",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-12",
      "bookedDate": "2026-09-18",
      "roomType": "Double Queen",
      "rate": 131,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1009132",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-12",
      "bookedDate": "2026-09-22",
      "roomType": "Double Queen",
      "rate": 129,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1009166",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-12",
      "bookedDate": "2026-09-25",
      "roomType": "King",
      "rate": 134,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1009257",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-13",
      "bookedDate": "2026-09-01",
      "roomType": "King",
      "rate": 144,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1009265",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-13",
      "bookedDate": "2026-09-19",
      "roomType": "Double Queen",
      "rate": 150,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1009303",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-13",
      "bookedDate": "2026-10-02",
      "roomType": "King",
      "rate": 147,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1009331",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-13",
      "bookedDate": "2026-09-15",
      "roomType": "King",
      "rate": 146,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1009366",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-13",
      "bookedDate": "2026-09-01",
      "roomType": "Double Queen",
      "rate": 144,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1009257",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-14",
      "bookedDate": "2026-09-01",
      "roomType": "King",
      "rate": 140,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1009265",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-14",
      "bookedDate": "2026-09-19",
      "roomType": "Double Queen",
      "rate": 139,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1009398",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-14",
      "bookedDate": "2026-09-26",
      "roomType": "Double Queen",
      "rate": 141,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1009462",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-14",
      "bookedDate": "2026-10-03",
      "roomType": "Double Queen",
      "rate": 137,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1009531",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-14",
      "bookedDate": "2026-09-10",
      "roomType": "King",
      "rate": 139,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1009257",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-15",
      "bookedDate": "2026-09-01",
      "roomType": "King",
      "rate": 113,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1009398",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-15",
      "bookedDate": "2026-09-26",
      "roomType": "Double Queen",
      "rate": 114,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1009462",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-15",
      "bookedDate": "2026-10-03",
      "roomType": "Double Queen",
      "rate": 114,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1009257",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-16",
      "bookedDate": "2026-09-01",
      "roomType": "King",
      "rate": 128,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1009398",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-16",
      "bookedDate": "2026-09-26",
      "roomType": "Double Queen",
      "rate": 129,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1009462",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-16",
      "bookedDate": "2026-10-03",
      "roomType": "Double Queen",
      "rate": 128,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1009606",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-16",
      "bookedDate": "2026-10-02",
      "roomType": "Double Queen",
      "rate": 134,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1009684",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-16",
      "bookedDate": "2026-09-09",
      "roomType": "King",
      "rate": 129,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1009398",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-17",
      "bookedDate": "2026-09-26",
      "roomType": "Double Queen",
      "rate": 131,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1009777",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-17",
      "bookedDate": "2026-09-30",
      "roomType": "Double Queen",
      "rate": 135,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1009861",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-17",
      "bookedDate": "2026-09-26",
      "roomType": "King Suite",
      "rate": 155,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1009777",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-18",
      "bookedDate": "2026-09-30",
      "roomType": "Double Queen",
      "rate": 136,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1009861",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-18",
      "bookedDate": "2026-09-26",
      "roomType": "King Suite",
      "rate": 162,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1009928",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-18",
      "bookedDate": "2026-09-26",
      "roomType": "King",
      "rate": 133,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1009777",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-19",
      "bookedDate": "2026-09-30",
      "roomType": "Double Queen",
      "rate": 135,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1009861",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-19",
      "bookedDate": "2026-09-26",
      "roomType": "King Suite",
      "rate": 158,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1009928",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-19",
      "bookedDate": "2026-09-26",
      "roomType": "King",
      "rate": 133,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1009777",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-20",
      "bookedDate": "2026-09-30",
      "roomType": "Double Queen",
      "rate": 146,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1009928",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-20",
      "bookedDate": "2026-09-26",
      "roomType": "King",
      "rate": 149,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1009992",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-20",
      "bookedDate": "2026-09-04",
      "roomType": "King",
      "rate": 143,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1010051",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-20",
      "bookedDate": "2026-09-07",
      "roomType": "Double Queen",
      "rate": 146,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1010072",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-20",
      "bookedDate": "2026-09-01",
      "roomType": "Double Queen",
      "rate": 149,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1009992",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-21",
      "bookedDate": "2026-09-04",
      "roomType": "King",
      "rate": 153,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1010084",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-21",
      "bookedDate": "2026-09-24",
      "roomType": "King Suite",
      "rate": 174,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1010167",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-21",
      "bookedDate": "2026-09-05",
      "roomType": "Double Queen",
      "rate": 152,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1010250",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-21",
      "bookedDate": "2026-09-24",
      "roomType": "King",
      "rate": 146,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1010323",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-21",
      "bookedDate": "2026-09-10",
      "roomType": "King",
      "rate": 149,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1009992",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-22",
      "bookedDate": "2026-09-04",
      "roomType": "King",
      "rate": 116,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1010084",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-22",
      "bookedDate": "2026-09-24",
      "roomType": "King Suite",
      "rate": 140,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1009992",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-23",
      "bookedDate": "2026-09-04",
      "roomType": "King",
      "rate": 131,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1010084",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-23",
      "bookedDate": "2026-09-24",
      "roomType": "King Suite",
      "rate": 155,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1010345",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-23",
      "bookedDate": "2026-10-03",
      "roomType": "King",
      "rate": 132,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1010084",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-24",
      "bookedDate": "2026-09-24",
      "roomType": "King Suite",
      "rate": 156,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1010345",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-24",
      "bookedDate": "2026-10-03",
      "roomType": "King",
      "rate": 136,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1010378",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-24",
      "bookedDate": "2026-09-07",
      "roomType": "King",
      "rate": 130,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1010418",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-24",
      "bookedDate": "2026-09-10",
      "roomType": "King Suite",
      "rate": 160,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1010084",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-25",
      "bookedDate": "2026-09-24",
      "roomType": "King Suite",
      "rate": 156,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1010345",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-25",
      "bookedDate": "2026-10-03",
      "roomType": "King",
      "rate": 135,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1010488",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-25",
      "bookedDate": "2026-09-19",
      "roomType": "King",
      "rate": 137,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1010084",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-26",
      "bookedDate": "2026-09-24",
      "roomType": "King Suite",
      "rate": 142,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1010516",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-26",
      "bookedDate": "2026-09-06",
      "roomType": "Double Queen",
      "rate": 117,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1010084",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-27",
      "bookedDate": "2026-09-24",
      "roomType": "King Suite",
      "rate": 169,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1010599",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-27",
      "bookedDate": "2026-09-13",
      "roomType": "Double Queen",
      "rate": 144,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1010654",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-27",
      "bookedDate": "2026-09-04",
      "roomType": "Double Queen",
      "rate": 145,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1010084",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-28",
      "bookedDate": "2026-09-24",
      "roomType": "King Suite",
      "rate": 173,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1010599",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-28",
      "bookedDate": "2026-09-13",
      "roomType": "Double Queen",
      "rate": 152,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1010668",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-28",
      "bookedDate": "2026-09-01",
      "roomType": "King",
      "rate": 147,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1010702",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-28",
      "bookedDate": "2026-09-12",
      "roomType": "Double Queen",
      "rate": 146,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1010778",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-28",
      "bookedDate": "2026-09-01",
      "roomType": "King",
      "rate": 153,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1010872",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-28",
      "bookedDate": "2026-09-25",
      "roomType": "Double Queen",
      "rate": 148,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1010668",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-29",
      "bookedDate": "2026-09-01",
      "roomType": "King",
      "rate": 112,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1010932",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-29",
      "bookedDate": "2026-10-03",
      "roomType": "King",
      "rate": 113,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1010668",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-30",
      "bookedDate": "2026-09-01",
      "roomType": "King",
      "rate": 131,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1010932",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-30",
      "bookedDate": "2026-10-03",
      "roomType": "King",
      "rate": 130,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1010938",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-11-30",
      "bookedDate": "2026-09-02",
      "roomType": "King",
      "rate": 129,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1010932",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-01",
      "bookedDate": "2026-10-03",
      "roomType": "King",
      "rate": 127,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1011030",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-01",
      "bookedDate": "2026-09-29",
      "roomType": "King",
      "rate": 130,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1011097",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-01",
      "bookedDate": "2026-09-18",
      "roomType": "King",
      "rate": 131,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1011030",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-02",
      "bookedDate": "2026-09-29",
      "roomType": "King",
      "rate": 129,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1011159",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-02",
      "bookedDate": "2026-09-26",
      "roomType": "King",
      "rate": 134,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1011215",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-02",
      "bookedDate": "2026-09-03",
      "roomType": "King",
      "rate": 133,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1011030",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-03",
      "bookedDate": "2026-09-29",
      "roomType": "King",
      "rate": 128,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1011290",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-03",
      "bookedDate": "2026-09-21",
      "roomType": "Double Queen",
      "rate": 126,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1011030",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-04",
      "bookedDate": "2026-09-29",
      "roomType": "King",
      "rate": 140,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1011338",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-04",
      "bookedDate": "2026-09-16",
      "roomType": "King Suite",
      "rate": 164,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1011030",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-05",
      "bookedDate": "2026-09-29",
      "roomType": "King",
      "rate": 144,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1011338",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-05",
      "bookedDate": "2026-09-16",
      "roomType": "King Suite",
      "rate": 171,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1011391",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-05",
      "bookedDate": "2026-09-30",
      "roomType": "Double Queen",
      "rate": 148,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1011030",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-06",
      "bookedDate": "2026-09-29",
      "roomType": "King",
      "rate": 112,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1011338",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-06",
      "bookedDate": "2026-09-16",
      "roomType": "King Suite",
      "rate": 137,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1011391",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-06",
      "bookedDate": "2026-09-30",
      "roomType": "Double Queen",
      "rate": 111,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1011338",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-07",
      "bookedDate": "2026-09-16",
      "roomType": "King Suite",
      "rate": 151,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1011426",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-07",
      "bookedDate": "2026-09-08",
      "roomType": "Double Queen",
      "rate": 130,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1011426",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-08",
      "bookedDate": "2026-09-08",
      "roomType": "Double Queen",
      "rate": 130,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1011494",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-08",
      "bookedDate": "2026-09-18",
      "roomType": "King",
      "rate": 132,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1011534",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-09",
      "bookedDate": "2026-09-27",
      "roomType": "Double Queen",
      "rate": 132,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1011573",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-09",
      "bookedDate": "2026-09-30",
      "roomType": "Double Queen",
      "rate": 132,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1011634",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-10",
      "bookedDate": "2026-09-20",
      "roomType": "Double Queen",
      "rate": 128,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1011634",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-11",
      "bookedDate": "2026-09-20",
      "roomType": "Double Queen",
      "rate": 142,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1011686",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-11",
      "bookedDate": "2026-09-26",
      "roomType": "King",
      "rate": 145,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1011719",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-11",
      "bookedDate": "2026-09-21",
      "roomType": "Double Queen",
      "rate": 141,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1011634",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-12",
      "bookedDate": "2026-09-20",
      "roomType": "Double Queen",
      "rate": 147,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1011686",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-12",
      "bookedDate": "2026-09-26",
      "roomType": "King",
      "rate": 142,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1011729",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-13",
      "bookedDate": "2026-09-25",
      "roomType": "Double Queen",
      "rate": 113,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1011818",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-13",
      "bookedDate": "2026-09-10",
      "roomType": "King",
      "rate": 109,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1011856",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-14",
      "bookedDate": "2026-09-07",
      "roomType": "Double Queen",
      "rate": 129,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1011939",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-14",
      "bookedDate": "2026-09-09",
      "roomType": "King",
      "rate": 127,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1011856",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-15",
      "bookedDate": "2026-09-07",
      "roomType": "Double Queen",
      "rate": 128,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1011856",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-16",
      "bookedDate": "2026-09-07",
      "roomType": "Double Queen",
      "rate": 133,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1011977",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-16",
      "bookedDate": "2026-09-08",
      "roomType": "King",
      "rate": 130,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1011856",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-17",
      "bookedDate": "2026-09-07",
      "roomType": "Double Queen",
      "rate": 128,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1012029",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-17",
      "bookedDate": "2026-09-21",
      "roomType": "King",
      "rate": 132,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1011856",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-18",
      "bookedDate": "2026-09-07",
      "roomType": "Double Queen",
      "rate": 143,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1012080",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-19",
      "bookedDate": "2026-09-15",
      "roomType": "King",
      "rate": 144,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1012114",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-19",
      "bookedDate": "2026-09-21",
      "roomType": "King",
      "rate": 148,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1012080",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-20",
      "bookedDate": "2026-09-15",
      "roomType": "King",
      "rate": 111,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1012156",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-21",
      "bookedDate": "2026-09-28",
      "roomType": "Double Queen",
      "rate": 128,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1012204",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-21",
      "bookedDate": "2026-09-03",
      "roomType": "Double Queen",
      "rate": 130,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1012219",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-22",
      "bookedDate": "2026-09-27",
      "roomType": "King",
      "rate": 129,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1012246",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-22",
      "bookedDate": "2026-09-27",
      "roomType": "Double Queen",
      "rate": 130,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1012219",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-23",
      "bookedDate": "2026-09-27",
      "roomType": "King",
      "rate": 131,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1012270",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-23",
      "bookedDate": "2026-09-24",
      "roomType": "King",
      "rate": 133,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1012219",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-24",
      "bookedDate": "2026-09-27",
      "roomType": "King",
      "rate": 132,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1012338",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-25",
      "bookedDate": "2026-09-27",
      "roomType": "Double Queen",
      "rate": 145,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1012393",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-26",
      "bookedDate": "2026-09-12",
      "roomType": "King",
      "rate": 164,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1012488",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-27",
      "bookedDate": "2026-09-03",
      "roomType": "Double Queen",
      "rate": 125,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1012529",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-28",
      "bookedDate": "2026-09-26",
      "roomType": "Double Queen",
      "rate": 148,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1012529",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-29",
      "bookedDate": "2026-09-26",
      "roomType": "Double Queen",
      "rate": 146,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1012602",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-29",
      "bookedDate": "2026-09-18",
      "roomType": "King Suite",
      "rate": 174,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1012602",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-30",
      "bookedDate": "2026-09-18",
      "roomType": "King Suite",
      "rate": 176,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1012608",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-30",
      "bookedDate": "2026-09-07",
      "roomType": "King",
      "rate": 151,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1012602",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-31",
      "bookedDate": "2026-09-18",
      "roomType": "King Suite",
      "rate": 210,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1012608",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-31",
      "bookedDate": "2026-09-07",
      "roomType": "King",
      "rate": 188,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1012618",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-31",
      "bookedDate": "2026-09-01",
      "roomType": "Double Queen",
      "rate": 184,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1012695",
      "promotionId": "P-101",
      "channel": "Booking.com",
      "stayDate": "2026-12-31",
      "bookedDate": "2026-09-05",
      "roomType": "King",
      "rate": 186,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1012748",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-04",
      "bookedDate": "2026-09-28",
      "roomType": "Double Queen",
      "rate": 97,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1012781",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-04",
      "bookedDate": "2026-09-17",
      "roomType": "King",
      "rate": 100,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1012806",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-04",
      "bookedDate": "2026-09-20",
      "roomType": "King",
      "rate": 99,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1012748",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-05",
      "bookedDate": "2026-09-28",
      "roomType": "Double Queen",
      "rate": 121,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1012781",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-05",
      "bookedDate": "2026-09-17",
      "roomType": "King",
      "rate": 118,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1012806",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-05",
      "bookedDate": "2026-09-20",
      "roomType": "King",
      "rate": 121,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1012817",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-05",
      "bookedDate": "2026-09-17",
      "roomType": "Double Queen",
      "rate": 119,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1012871",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-05",
      "bookedDate": "2026-10-02",
      "roomType": "Double Queen",
      "rate": 117,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1012911",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-05",
      "bookedDate": "2026-09-22",
      "roomType": "Double Queen",
      "rate": 119,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1012748",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-06",
      "bookedDate": "2026-09-28",
      "roomType": "Double Queen",
      "rate": 117,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1012817",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-06",
      "bookedDate": "2026-09-17",
      "roomType": "Double Queen",
      "rate": 113,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1012871",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-06",
      "bookedDate": "2026-10-02",
      "roomType": "Double Queen",
      "rate": 115,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1012922",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-06",
      "bookedDate": "2026-09-13",
      "roomType": "King",
      "rate": 115,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1012984",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-06",
      "bookedDate": "2026-09-19",
      "roomType": "King",
      "rate": 114,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1013058",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-06",
      "bookedDate": "2026-09-24",
      "roomType": "Double Queen",
      "rate": 113,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1012922",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-07",
      "bookedDate": "2026-09-13",
      "roomType": "King",
      "rate": 117,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1013135",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-07",
      "bookedDate": "2026-09-16",
      "roomType": "King",
      "rate": 115,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1013224",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-07",
      "bookedDate": "2026-09-14",
      "roomType": "King Suite",
      "rate": 143,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1013274",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-07",
      "bookedDate": "2026-09-27",
      "roomType": "King",
      "rate": 115,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1012922",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-08",
      "bookedDate": "2026-09-13",
      "roomType": "King",
      "rate": 108,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1013135",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-08",
      "bookedDate": "2026-09-16",
      "roomType": "King",
      "rate": 108,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1013224",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-08",
      "bookedDate": "2026-09-14",
      "roomType": "King Suite",
      "rate": 131,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1013311",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-08",
      "bookedDate": "2026-10-03",
      "roomType": "Double Queen",
      "rate": 109,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1013353",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-08",
      "bookedDate": "2026-09-10",
      "roomType": "King",
      "rate": 106,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1013397",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-08",
      "bookedDate": "2026-09-16",
      "roomType": "Double Queen",
      "rate": 109,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1012922",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-09",
      "bookedDate": "2026-09-13",
      "roomType": "King",
      "rate": 124,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1013436",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-09",
      "bookedDate": "2026-09-21",
      "roomType": "King",
      "rate": 129,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1013455",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-09",
      "bookedDate": "2026-09-18",
      "roomType": "King",
      "rate": 129,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1013510",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-09",
      "bookedDate": "2026-09-10",
      "roomType": "Double Queen",
      "rate": 125,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1012922",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-10",
      "bookedDate": "2026-09-13",
      "roomType": "King",
      "rate": 127,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1013436",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-10",
      "bookedDate": "2026-09-21",
      "roomType": "King",
      "rate": 124,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1013455",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-10",
      "bookedDate": "2026-09-18",
      "roomType": "King",
      "rate": 124,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1013510",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-10",
      "bookedDate": "2026-09-10",
      "roomType": "Double Queen",
      "rate": 125,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1013606",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-10",
      "bookedDate": "2026-09-17",
      "roomType": "Double Queen",
      "rate": 123,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1013614",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-10",
      "bookedDate": "2026-09-27",
      "roomType": "King",
      "rate": 124,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1013646",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-10",
      "bookedDate": "2026-09-28",
      "roomType": "Double Queen",
      "rate": 129,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1013734",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-10",
      "bookedDate": "2026-10-01",
      "roomType": "Double Queen",
      "rate": 124,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1012922",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-11",
      "bookedDate": "2026-09-13",
      "roomType": "King",
      "rate": 101,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1013436",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-11",
      "bookedDate": "2026-09-21",
      "roomType": "King",
      "rate": 101,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1013742",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-11",
      "bookedDate": "2026-09-28",
      "roomType": "Double Queen",
      "rate": 98,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1013756",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-11",
      "bookedDate": "2026-09-23",
      "roomType": "Double Queen",
      "rate": 100,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1013794",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-11",
      "bookedDate": "2026-09-26",
      "roomType": "King",
      "rate": 99,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1012922",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-12",
      "bookedDate": "2026-09-13",
      "roomType": "King",
      "rate": 112,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1013742",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-12",
      "bookedDate": "2026-09-28",
      "roomType": "Double Queen",
      "rate": 115,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1013891",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-12",
      "bookedDate": "2026-10-02",
      "roomType": "Double Queen",
      "rate": 113,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1013959",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-12",
      "bookedDate": "2026-09-14",
      "roomType": "Double Queen",
      "rate": 116,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1014033",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-12",
      "bookedDate": "2026-09-18",
      "roomType": "King",
      "rate": 115,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1013742",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-13",
      "bookedDate": "2026-09-28",
      "roomType": "Double Queen",
      "rate": 116,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1013891",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-13",
      "bookedDate": "2026-10-02",
      "roomType": "Double Queen",
      "rate": 115,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1013959",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-13",
      "bookedDate": "2026-09-14",
      "roomType": "Double Queen",
      "rate": 117,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1014033",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-13",
      "bookedDate": "2026-09-18",
      "roomType": "King",
      "rate": 116,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1014097",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-13",
      "bookedDate": "2026-09-17",
      "roomType": "Double Queen",
      "rate": 117,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1014117",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-13",
      "bookedDate": "2026-10-02",
      "roomType": "King",
      "rate": 115,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1013742",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-14",
      "bookedDate": "2026-09-28",
      "roomType": "Double Queen",
      "rate": 115,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1013891",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-14",
      "bookedDate": "2026-10-02",
      "roomType": "Double Queen",
      "rate": 119,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1013959",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-14",
      "bookedDate": "2026-09-14",
      "roomType": "Double Queen",
      "rate": 120,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1014097",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-14",
      "bookedDate": "2026-09-17",
      "roomType": "Double Queen",
      "rate": 117,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1014141",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-14",
      "bookedDate": "2026-10-01",
      "roomType": "Double Queen",
      "rate": 117,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1014170",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-14",
      "bookedDate": "2026-09-13",
      "roomType": "Double Queen",
      "rate": 117,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1014210",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-14",
      "bookedDate": "2026-09-15",
      "roomType": "Double Queen",
      "rate": 117,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1014141",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-15",
      "bookedDate": "2026-10-01",
      "roomType": "Double Queen",
      "rate": 113,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1014304",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-15",
      "bookedDate": "2026-09-20",
      "roomType": "King Suite",
      "rate": 138,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1014362",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-15",
      "bookedDate": "2026-09-25",
      "roomType": "King",
      "rate": 112,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1014447",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-15",
      "bookedDate": "2026-09-19",
      "roomType": "Double Queen",
      "rate": 116,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1014304",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-16",
      "bookedDate": "2026-09-20",
      "roomType": "King Suite",
      "rate": 145,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1014362",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-16",
      "bookedDate": "2026-09-25",
      "roomType": "King",
      "rate": 117,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1014487",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-16",
      "bookedDate": "2026-09-21",
      "roomType": "King",
      "rate": 121,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1014511",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-16",
      "bookedDate": "2026-09-13",
      "roomType": "Double Queen",
      "rate": 120,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1014304",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-17",
      "bookedDate": "2026-09-20",
      "roomType": "King Suite",
      "rate": 140,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1014487",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-17",
      "bookedDate": "2026-09-21",
      "roomType": "King",
      "rate": 114,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1014561",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-17",
      "bookedDate": "2026-09-18",
      "roomType": "King",
      "rate": 116,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1014654",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-17",
      "bookedDate": "2026-09-22",
      "roomType": "King Suite",
      "rate": 141,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1014677",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-17",
      "bookedDate": "2026-09-19",
      "roomType": "Double Queen",
      "rate": 114,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1014731",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-17",
      "bookedDate": "2026-09-12",
      "roomType": "King Suite",
      "rate": 141,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1014304",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-18",
      "bookedDate": "2026-09-20",
      "roomType": "King Suite",
      "rate": 122,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1014799",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-18",
      "bookedDate": "2026-09-23",
      "roomType": "King",
      "rate": 97,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1014845",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-18",
      "bookedDate": "2026-09-12",
      "roomType": "King",
      "rate": 101,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1014304",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-19",
      "bookedDate": "2026-09-20",
      "roomType": "King Suite",
      "rate": 137,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1014799",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-19",
      "bookedDate": "2026-09-23",
      "roomType": "King",
      "rate": 113,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1014920",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-19",
      "bookedDate": "2026-10-01",
      "roomType": "King",
      "rate": 111,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1015003",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-19",
      "bookedDate": "2026-09-14",
      "roomType": "King Suite",
      "rate": 139,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1014304",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-20",
      "bookedDate": "2026-09-20",
      "roomType": "King Suite",
      "rate": 141,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1014920",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-20",
      "bookedDate": "2026-10-01",
      "roomType": "King",
      "rate": 116,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1015044",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-20",
      "bookedDate": "2026-09-28",
      "roomType": "Double Queen",
      "rate": 115,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1015085",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-20",
      "bookedDate": "2026-09-20",
      "roomType": "Double Queen",
      "rate": 117,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1014304",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-21",
      "bookedDate": "2026-09-20",
      "roomType": "King Suite",
      "rate": 143,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1015044",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-21",
      "bookedDate": "2026-09-28",
      "roomType": "Double Queen",
      "rate": 115,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1015141",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-21",
      "bookedDate": "2026-09-21",
      "roomType": "Double Queen",
      "rate": 117,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1015214",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-21",
      "bookedDate": "2026-10-03",
      "roomType": "King",
      "rate": 116,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1015249",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-22",
      "bookedDate": "2026-10-02",
      "roomType": "Double Queen",
      "rate": 110,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1015266",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-22",
      "bookedDate": "2026-10-03",
      "roomType": "Double Queen",
      "rate": 109,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1015249",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-23",
      "bookedDate": "2026-10-02",
      "roomType": "Double Queen",
      "rate": 126,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1015266",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-23",
      "bookedDate": "2026-10-03",
      "roomType": "Double Queen",
      "rate": 130,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1015339",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-23",
      "bookedDate": "2026-09-26",
      "roomType": "Double Queen",
      "rate": 124,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1015434",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-23",
      "bookedDate": "2026-09-26",
      "roomType": "King",
      "rate": 126,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1015249",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-24",
      "bookedDate": "2026-10-02",
      "roomType": "Double Queen",
      "rate": 111,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1015454",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-24",
      "bookedDate": "2026-09-21",
      "roomType": "Double Queen",
      "rate": 112,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1015484",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-24",
      "bookedDate": "2026-09-24",
      "roomType": "King",
      "rate": 113,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1015566",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-24",
      "bookedDate": "2026-09-16",
      "roomType": "Double Queen",
      "rate": 116,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1015454",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-25",
      "bookedDate": "2026-09-21",
      "roomType": "Double Queen",
      "rate": 100,
      "status": "Cancelled"
    },
    {
      "confirmation": "BK1015612",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-25",
      "bookedDate": "2026-10-03",
      "roomType": "Double Queen",
      "rate": 97,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1015707",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-25",
      "bookedDate": "2026-09-25",
      "roomType": "King",
      "rate": 97,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1015612",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-26",
      "bookedDate": "2026-10-03",
      "roomType": "Double Queen",
      "rate": 113,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1015724",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-26",
      "bookedDate": "2026-09-11",
      "roomType": "King Suite",
      "rate": 137,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1015724",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-27",
      "bookedDate": "2026-09-11",
      "roomType": "King Suite",
      "rate": 142,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1015741",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-27",
      "bookedDate": "2026-09-10",
      "roomType": "Double Queen",
      "rate": 114,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1015829",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-27",
      "bookedDate": "2026-09-22",
      "roomType": "Double Queen",
      "rate": 113,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1015866",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-27",
      "bookedDate": "2026-09-24",
      "roomType": "King",
      "rate": 113,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1015873",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-28",
      "bookedDate": "2026-09-12",
      "roomType": "King",
      "rate": 118,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1015936",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-28",
      "bookedDate": "2026-09-15",
      "roomType": "Double Queen",
      "rate": 116,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1015873",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-29",
      "bookedDate": "2026-09-12",
      "roomType": "King",
      "rate": 115,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1015936",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-29",
      "bookedDate": "2026-09-15",
      "roomType": "Double Queen",
      "rate": 115,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1015985",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-29",
      "bookedDate": "2026-09-20",
      "roomType": "Double Queen",
      "rate": 113,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1016015",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-29",
      "bookedDate": "2026-09-15",
      "roomType": "Double Queen",
      "rate": 114,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1016063",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-29",
      "bookedDate": "2026-09-20",
      "roomType": "King",
      "rate": 114,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1016071",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-29",
      "bookedDate": "2026-09-30",
      "roomType": "King",
      "rate": 114,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1015985",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-30",
      "bookedDate": "2026-09-20",
      "roomType": "Double Queen",
      "rate": 125,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1016141",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-30",
      "bookedDate": "2026-09-28",
      "roomType": "King Suite",
      "rate": 149,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1016156",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-30",
      "bookedDate": "2026-09-16",
      "roomType": "Double Queen",
      "rate": 128,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1016141",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-31",
      "bookedDate": "2026-09-28",
      "roomType": "King Suite",
      "rate": 150,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1016156",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-31",
      "bookedDate": "2026-09-16",
      "roomType": "Double Queen",
      "rate": 125,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1016177",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-10-31",
      "bookedDate": "2026-10-01",
      "roomType": "King",
      "rate": 122,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1016177",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-11-01",
      "bookedDate": "2026-10-01",
      "roomType": "King",
      "rate": 97,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1016241",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-11-01",
      "bookedDate": "2026-09-26",
      "roomType": "King",
      "rate": 94,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1016177",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-11-02",
      "bookedDate": "2026-10-01",
      "roomType": "King",
      "rate": 106,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1016241",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-11-02",
      "bookedDate": "2026-09-26",
      "roomType": "King",
      "rate": 107,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1016302",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-11-02",
      "bookedDate": "2026-09-22",
      "roomType": "King",
      "rate": 108,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1016177",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-11-03",
      "bookedDate": "2026-10-01",
      "roomType": "King",
      "rate": 112,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1016348",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-11-03",
      "bookedDate": "2026-09-12",
      "roomType": "King Suite",
      "rate": 133,
      "status": "Confirmed"
    },
    {
      "confirmation": "BK1016177",
      "promotionId": "P-102",
      "channel": "Booking.com",
      "stayDate": "2026-11-04",
      "bookedDate": "2026-10-01",
      "roomType": "King",
      "rate": 110,
      "status": "Confirmed"
    }
  ]
};

export default sampleData;
